(function(){
/* core.js */
const TAU=Math.PI*2;
const SHAPES={
emeraude:{n:'Émeraude',t:'taille émeraude',r:1.32,c:0.45,steps:true},
ovale:{n:'Ovale',t:'taille ovale',r:1.35,c:0.40,steps:false},
coussin:{n:'Coussin',t:'taille coussin',r:1.12,c:0.375,steps:true},
poire:{n:'Poire',t:'taille poire',r:1.55,c:0.36,steps:false},
rond:{n:'Rond',t:'taille ronde',r:1,c:0.28,steps:false},
baguette:{n:'Baguette',t:'taille baguette',r:1.8,c:0.62,steps:true}};
const METALS={
jaune:{n:'Or jaune 18 ct',c:['#fbebb5','#e4be6a','#b58a35','#8a6522'],d:15.5},
blanc:{n:'Or blanc 18 ct',c:['#fafbfc','#d5d9dc','#9ea4aa','#737980'],d:15.6},
rose:{n:'Or rose 18 ct',c:['#fadccc','#e8b096','#c0836a','#925a43'],d:15.2}};
const TINTS={
transparent:{n:'Transparent',s:'légèrement teinté',d:'transparent légèrement teinté',c:['#f2fbf8','#d9efe9','#b9dcd4','#93bfb5']},
clair:{n:'Vert clair',s:'lumineux et doux',d:'vert clair',c:['#d6f5df','#9fe0b4','#5fc085','#2f8f5a']},
vivid:{n:'Vert vivid',s:'saturation maximale',d:'vert vivid',c:['#b5f0cb','#4cc07f','#169a58','#0a5e36']},
muzo:{n:'Muzo Green',s:'le vert typique',d:'vert Muzo',c:['#9fe0b6','#2fa863','#0c7a42','#044a27']},
chivor:{n:'Chivor Green',s:'teinte bleutée',d:'vert Chivor, bleuté',c:['#a6ebdd','#3db8a0','#128a78','#065148']},
coscuez:{n:'Coscuez Green',s:'teinte jaune',d:'vert Coscuez, tirant sur le jaune',c:['#d4f0b0','#7cc45a','#3f9a3a','#20602a']},
intense:{n:'Vert intense',s:'franc et soutenu',d:'vert intense',c:['#a8e3bf','#3aad6e','#13804a','#07502d']},
profond:{n:'Vert profond',s:'sombre et dense',d:'vert profond',c:['#6fb08a','#1f7a4e','#0a5132','#032617']}};
const TINT_ALIASES={vif:'vivid',bleute:'chivor'};
const HALO_RANGS={simple:{n:'halo simple'},double:{n:'double halo'}};
const PAVE_ETENDUES={epaules:{n:'pavé sur les épaules'},demi:{n:'pavé demi-tour'},complet:{n:'pavé tour complet'}};
const GRIFFES={classiques:{n:'griffes classiques'},six:{n:'six griffes'},doubles:{n:'griffes doubles'},v:{n:'griffes en V aux angles'}};
const GRIFFES_V=['emeraude','poire','baguette'];
const LAT_FORMES={rond:{n:'ronde'},poire:{n:'poire'},baguette:{n:'baguette'},trapeze:{n:'trapèze'}};
const LAT_TAILLES={petite:{n:'petit format',k:.82},moyenne:{n:'format moyen',k:1},grande:{n:'grand format',k:1.18}};
const PROFILS={bombe:{n:'bombé'},plat:{n:'plat'},divise:{n:'divisé sous la pierre'}};
const HAUTEURS={basse:{n:'sertissage bas',dy:0},haute:{n:'sertissage haut',dy:1.3}};
const ALLIANCES={aucune:{n:'aucune'},lisse:{n:'alliance lisse assortie'},pavee:{n:'alliance pavée assortie'}};
const POLICES={classique:{n:'classique'},manuscrite:{n:'manuscrite'},baton:{n:'bâton'}};
const griffesOf=S=>S.griffes==='v'&&!GRIFFES_V.includes(S.forme)?'classiques':(GRIFFES[S.griffes]?S.griffes:'classiques');
const JONCS={fin:{n:'fin',w:1.7,t:1.8},moyen:{n:'moyen',w:2.3,t:2},large:{n:'large',w:3,t:2.2}};
const MONT={
solitaire:{n:'Solitaire',head:0.45,gal:3.2},
halo:{n:'Halo',head:0.9,gal:2.8},
trois:{n:'Trois pierres',head:1.1,gal:2.6},
clos:{n:'Serti clos',head:0.9,gal:1.6}};

const f1=n=>n.toFixed(1);
const fm=(n,d=2)=>n.toFixed(d).replace('.',',');
const dims=(f,ct)=>{const s=SHAPES[f];const W=Math.cbrt(ct/(0.0136*s.c));return{W,L:W*s.r,D:W*0.62};};

function sample(shape,w,h){
const a=w/2,b=h/2,pts=[];
if(shape==='baguette'){const c=0.06*Math.min(w,h);return[[-a+c,-b],[a-c,-b],[a,-b+c],[a,b-c],[a-c,b],[-a+c,b],[-a,b-c],[-a,-b+c]];}
if(shape==='emeraude'){const c=0.2*Math.min(w,h);return[[-a+c,-b],[a-c,-b],[a,-b+c],[a,b-c],[a-c,b],[-a+c,b],[-a,b-c],[-a,-b+c]];}
if(shape==='ovale'||shape==='rond'){for(let i=0;i<96;i++){const t=i/96*TAU;pts.push([a*Math.cos(t),b*Math.sin(t)]);}return pts;}
if(shape==='coussin'){for(let i=0;i<88;i++){const t=i/88*TAU,co=Math.cos(t),si=Math.sin(t);pts.push([a*Math.sign(co)*Math.pow(Math.abs(co),0.6),b*Math.sign(si)*Math.pow(Math.abs(si),0.6)]);}return pts;}
const raw=[];let mx=0;
for(let i=0;i<96;i++){const t=i/96*TAU;const x=Math.sin(t)*Math.pow(Math.sin(t/2),1.3);raw.push([x,Math.cos(t)]);mx=Math.max(mx,Math.abs(x));}
return raw.map(q=>[q[0]/mx*a,-q[1]*b]);
}

function along(pts,step){
const n=pts.length,seg=[];let tot=0;
for(let i=0;i<n;i++){const a=pts[i],b=pts[(i+1)%n];const l=Math.hypot(b[0]-a[0],b[1]-a[1]);seg.push(l);tot+=l;}
const cnt=Math.max(8,Math.round(tot/step)),out=[];
for(let k=0;k<cnt;k++){let d=k*tot/cnt,i=0;while(i<n-1&&d>seg[i]){d-=seg[i];i++;}const a=pts[i],b=pts[(i+1)%n],t=seg[i]?d/seg[i]:0;out.push([a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t]);}
return out;
}

function extreme(a,dx,dy){
let m=-1e9;for(const q of a)m=Math.max(m,q[0]*dx+q[1]*dy);
let sx=0,sy=0,n=0;
for(const q of a){if(q[0]*dx+q[1]*dy>m-0.12){sx+=q[0];sy+=q[1];n++;}}
return[sx/n,sy/n];
}

function defs(p,M,T){
const g=M.c,t=T.c;
return `<linearGradient id="${p}g" gradientUnits="userSpaceOnUse" x1="40" y1="40" x2="380" y2="380"><stop offset="0" stop-color="${g[0]}"/><stop offset=".3" stop-color="${g[1]}"/><stop offset=".55" stop-color="${g[2]}"/><stop offset=".8" stop-color="${g[1]}"/><stop offset="1" stop-color="${g[3]}"/></linearGradient>`+
`<radialGradient id="${p}e" cx=".4" cy=".35" r=".8"><stop offset="0" stop-color="${t[1]}"/><stop offset=".55" stop-color="${t[2]}"/><stop offset="1" stop-color="${t[3]}"/></radialGradient>`+
`<radialGradient id="${p}d" cx=".4" cy=".35" r=".8"><stop offset="0" stop-color="#ffffff"/><stop offset=".6" stop-color="#eef5f9"/><stop offset="1" stop-color="#b9cad6"/></radialGradient>`+
`<linearGradient id="${p}ec" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${t[0]}"/><stop offset="1" stop-color="${t[2]}"/></linearGradient>`+
`<linearGradient id="${p}ep" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${t[2]}"/><stop offset="1" stop-color="${t[3]}"/></linearGradient>`+
`<filter id="${p}b" x="-20%" y="-60%" width="140%" height="220%"><feGaussianBlur stdDeviation="5"/></filter>`;
}

function topView(S){
const sc=14.5,cx=210,cy=212,p='t';
const T=TINTS[S.teinte],M=METALS[S.metal],J=JONCS[S.jonc];
const{W,L}=dims(S.forme,S.carats);
const ri=S.taille/TAU,ro=ri+J.t;
const X=v=>cx+v*sc,Y=v=>cy+v*sc;
const pt=q=>f1(X(q[0]))+','+f1(Y(q[1]));
const path=a=>'M'+a.map(pt).join('L')+'Z';
const sh=S.forme,steps=SHAPES[sh].steps;
const shp=(k,d=0)=>sample(sh,W*k+2*d,L*k+2*d);
const gold=`url(#${p}g)`,dia=`url(#${p}d)`;
const dotStroke='stroke="#8293a0" stroke-width=".5"';
const brill=(x,y,r,id,em)=>{
const ln=em?'rgba(255,255,255,.5)':'rgba(110,130,145,.65)';
let s=`<circle cx="${f1(X(x))}" cy="${f1(Y(y))}" r="${f1(r*sc)}" fill="url(#${id})"/>`;
const o8=[];
for(let k=0;k<8;k++){const a=k*Math.PI/4+Math.PI/8;o8.push([x+r*.58*Math.cos(a),y+r*.58*Math.sin(a)]);
s+=`<line x1="${f1(X(o8[k][0]))}" y1="${f1(Y(o8[k][1]))}" x2="${f1(X(x+r*Math.cos(a)))}" y2="${f1(Y(y+r*Math.sin(a)))}" stroke="${ln}" stroke-width=".7"/>`;}
s+=`<polygon points="${o8.map(pt).join(' ')}" fill="rgba(255,255,255,${em?.16:.5})" stroke="${ln}" stroke-width=".8"/>`;
s+=`<circle cx="${f1(X(x))}" cy="${f1(Y(y))}" r="${f1(r*sc)}" fill="none" stroke="${ln}" stroke-width=".9"/>`;
return s;};

let o=`<defs>${defs(p,M,T)}<linearGradient id="${p}s" gradientUnits="userSpaceOnUse" x1="${f1(X(-ro))}" y1="0" x2="${f1(X(ro))}" y2="0"><stop offset="0" stop-color="${M.c[3]}"/><stop offset=".22" stop-color="${M.c[2]}"/><stop offset=".5" stop-color="${M.c[0]}"/><stop offset=".78" stop-color="${M.c[2]}"/><stop offset="1" stop-color="${M.c[3]}"/></linearGradient><linearGradient id="${p}v" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".4"/><stop offset=".5" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".3"/></linearGradient></defs>`;

o+=`<ellipse cx="${cx}" cy="${f1(Y(0)+J.w*sc*.9)}" rx="${f1(ro*sc*.9)}" ry="${f1(J.w*sc*.45)}" fill="#000" opacity=".35" filter="url(#${p}b)"/>`;
const rw=2*ro*sc,rh=J.w*sc;
o+=`<rect x="${f1(X(-ro))}" y="${f1(Y(-J.w/2))}" width="${f1(rw)}" height="${f1(rh)}" rx="${f1(rh/2)}" fill="url(#${p}s)"/>`;
o+=`<rect x="${f1(X(-ro))}" y="${f1(Y(-J.w/2))}" width="${f1(rw)}" height="${f1(rh)}" rx="${f1(rh/2)}" fill="url(#${p}v)"/>`;

if(S.pave){
const dd=Math.min(J.w*.64,1.5);
const edge=W/2+(S.monture==='halo'?1.9:S.monture==='clos'?1.0:.3)+.25;
const th0=Math.asin(Math.min(.95,edge/ro));
for(const sg of[-1,1]){
for(let th=th0+.03;th<1.38;th+=dd*1.15/ro){
const f=Math.max(.3,Math.cos(th));
o+=`<ellipse cx="${f1(X(sg*ro*Math.sin(th)))}" cy="${f1(Y(0))}" rx="${f1(dd/2*f*sc)}" ry="${f1(dd/2*sc)}" fill="${dia}" ${dotStroke}/>`;
}}}

if(S.monture==='halo'){
o+=`<path d="${path(shp(1,1.7))}" fill="${gold}" stroke="rgba(0,0,0,.28)" stroke-width=".7"/>`;
o+=`<path d="${path(shp(1,.28))}" fill="rgba(0,0,0,.3)"/>`;
for(const q of along(shp(1,.83),1.15))o+=`<circle cx="${f1(X(q[0]))}" cy="${f1(Y(q[1]))}" r="${f1(.55*sc)}" fill="${dia}" ${dotStroke}/>`;
}

if(S.monture==='trois'){
const ds=Math.min(4.4,Math.max(2.4,W*.55)),id=S.lat==='emeraude'?p+'e':p+'d';
for(const sg of[-1,1]){
const x=sg*(W/2+.85+ds/2);
o+=`<circle cx="${f1(X(x))}" cy="${f1(Y(0))}" r="${f1((ds/2+.5)*sc)}" fill="${gold}" stroke="rgba(0,0,0,.28)" stroke-width=".7"/>`;
o+=brill(x,0,ds/2,id,S.lat==='emeraude');
}}

if(S.monture==='clos'){
o+=`<path d="${path(shp(1,.95))}" fill="${gold}" stroke="rgba(0,0,0,.28)" stroke-width=".7"/>`;
o+=`<path d="${path(shp(1,.3))}" fill="rgba(0,0,0,.38)"/>`;
}

const base=shp(1);
o+=`<path d="${path(base)}" fill="url(#${p}e)"/>`;
const lv=steps?[.82,.64,.46]:[.8,.54];
const chain=[base,...lv.map(k=>shp(k))];
for(let j=1;j<chain.length;j++)o+=`<path d="${path(chain[j])}" fill="rgba(255,255,255,.07)" stroke="rgba(255,255,255,.4)" stroke-width=".9"/>`;
const idx=sh==='emeraude'||sh==='baguette'?[0,1,2,3,4,5,6,7]:sh==='coussin'?[0,11,22,33,44,55,66,77]:Array.from({length:12},(_,i)=>i*8);
for(let j=0;j<chain.length-1;j++)for(const i of idx){
const a=chain[j][i],b=chain[j+1][i];
o+=`<line x1="${f1(X(a[0]))}" y1="${f1(Y(a[1]))}" x2="${f1(X(b[0]))}" y2="${f1(Y(b[1]))}" stroke="rgba(255,255,255,.3)" stroke-width=".7"/>`;
}
o+=`<ellipse cx="${f1(X(-W*.14))}" cy="${f1(Y(-L*.2))}" rx="${f1(W*.12*sc)}" ry="${f1(L*.06*sc)}" transform="rotate(-28 ${f1(X(-W*.14))} ${f1(Y(-L*.2))})" fill="rgba(255,255,255,.24)"/>`;
o+=`<path d="${path(base)}" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="1.1"/>`;

if(S.monture!=='clos'){
const dirs=sh==='poire'?[[0,-1],[-1,.7],[1,.7]]:[[1,1],[-1,1],[1,-1],[-1,-1]];
const rp=(.5+.03*W)*sc;
for(const d of dirs){
const e=extreme(base,d[0],d[1]);
o+=`<circle cx="${f1(X(e[0]*.98))}" cy="${f1(Y(e[1]*.98))}" r="${f1(rp)}" fill="${gold}" stroke="rgba(0,0,0,.32)" stroke-width=".6"/>`;
o+=`<circle cx="${f1(X(e[0]*.98-.12))}" cy="${f1(Y(e[1]*.98-.12))}" r="${f1(rp*.35)}" fill="rgba(255,255,255,.55)"/>`;
}}

return `<svg viewBox="0 0 420 420" role="img" aria-label="Vue de dessus de la bague">${o}</svg>`;
}

function faceView(S){
const p='f',sh=S.forme;
const T=TINTS[S.teinte],M=METALS[S.metal],J=JONCS[S.jonc],mt=MONT[S.monture];
const{W,D}=dims(sh,S.carats);
const ri=S.taille/TAU,ro=ri+J.t;
const ch=D*.34,ph=D*.66,Wt=W*.64;
const gal=Math.max(mt.gal,ph+.6),gy=-ro-gal;
const top=gy-ch-.7,bot=ro;
const sc=Math.min(12.5,392/(bot-top));
const ox=210,oy=210-((top+bot)/2)*sc;
const X=v=>ox+v*sc,Y=v=>oy+v*sc;
const P=a=>a.map(q=>f1(X(q[0]))+','+f1(Y(q[1]))).join(' ');
const gold=`url(#${p}g)`,dia=`url(#${p}d)`;
const dotStroke='stroke="#8293a0" stroke-width=".5"';
const circ=r=>`M${f1(X(-r))} ${f1(Y(0))}a${f1(r*sc)} ${f1(r*sc)} 0 1 0 ${f1(2*r*sc)} 0a${f1(r*sc)} ${f1(r*sc)} 0 1 0 ${f1(-2*r*sc)} 0Z`;
const steps=SHAPES[sh].steps;
const ln=(x1,y1,x2,y2,c,w)=>`<line x1="${f1(X(x1))}" y1="${f1(Y(y1))}" x2="${f1(X(x2))}" y2="${f1(Y(y2))}" stroke="${c}" stroke-width="${w}"/>`;

const gem=(x,y,w,c,pv,fillC,fillP)=>{
const wt=w*.64;
let s=`<polygon points="${P([[x-w/2,y],[x+w/2,y],[x,y+pv]])}" fill="url(#${fillP})" stroke="rgba(255,255,255,.2)" stroke-width=".7"/>`;
s+=`<polygon points="${P([[x-w/2,y],[x+w/2,y],[x+wt/2,y-c],[x-wt/2,y-c]])}" fill="url(#${fillC})" stroke="rgba(120,140,155,.55)" stroke-width=".7"/>`;
s+=ln(x-w*.25,y,x-wt*.25,y-c,'rgba(120,140,155,.5)',.6)+ln(x+w*.25,y,x+wt*.25,y-c,'rgba(120,140,155,.5)',.6);
return s;};

let o=`<defs>${defs(p,M,T)}</defs>`;
o+=`<ellipse cx="${ox}" cy="${f1(Y(ro)+3)}" rx="${f1(ro*sc*.55)}" ry="7" fill="#000" opacity=".35" filter="url(#${p}b)"/>`;
o+=`<path d="${circ(ro)}${circ(ri)}" fill="${gold}" fill-rule="evenodd"/>`;
o+=`<circle cx="${ox}" cy="${f1(Y(0))}" r="${f1(ri*sc)}" fill="none" stroke="rgba(0,0,0,.3)" stroke-width="1.4"/>`;
o+=`<circle cx="${ox}" cy="${f1(Y(0))}" r="${f1(ro*sc)}" fill="none" stroke="rgba(255,255,255,.35)" stroke-width="1"/>`;

if(S.pave){
const r=.4,st=1.15*2*r/ro;
for(const sg of[-1,1])for(let th=.3;th<2.05;th+=st){
o+=`<circle cx="${f1(X(sg*(ro-.02)*Math.sin(th)))}" cy="${f1(Y(-(ro-.02)*Math.cos(th)))}" r="${f1(r*sc)}" fill="${dia}" ${dotStroke}/>`;
}}

if(S.monture==='halo'){
o+=`<rect x="${f1(X(-(W/2+1.8)))}" y="${f1(Y(gy+.02))}" width="${f1((W+3.6)*sc)}" height="${f1(.9*sc)}" rx="${f1(.4*sc)}" fill="${gold}" stroke="rgba(0,0,0,.25)" stroke-width=".6"/>`;
for(const sg of[-1,1]){const x=sg*(W/2+.85);
o+=`<polygon points="${P([[x-.55,gy+.1],[x-.38,gy-.5],[x+.38,gy-.5],[x+.55,gy+.1]])}" fill="${dia}" ${dotStroke}/>`;}
}

if(S.monture!=='clos'){
o+=`<polygon points="${P([[-W/2,gy],[W/2,gy],[0,gy+ph]])}" fill="url(#${p}ep)" stroke="rgba(255,255,255,.2)" stroke-width=".8"/>`;
o+=ln(-W*.25,gy,0,gy+ph,'rgba(255,255,255,.18)',.7)+ln(W*.25,gy,0,gy+ph,'rgba(255,255,255,.18)',.7);
}

o+=`<polygon points="${P([[-W/2,gy],[W/2,gy],[Wt/2,gy-ch],[-Wt/2,gy-ch]])}" fill="url(#${p}ec)" stroke="rgba(255,255,255,.45)" stroke-width=".9"/>`;
if(steps){
for(const k of[1/3,2/3]){const hw=W/2-(W/2-Wt/2)*k;o+=ln(-hw,gy-ch*k,hw,gy-ch*k,'rgba(255,255,255,.4)',.8);}
}else{
for(const i of[1,2,3])o+=ln(-W/2+i*W/4,gy,-Wt/2+i*Wt/4,gy-ch,'rgba(255,255,255,.4)',.8);
o+=ln(-W*.45,gy-ch*.5,W*.45,gy-ch*.5,'rgba(255,255,255,.28)',.7);
}
o+=`<rect x="${f1(X(-W/2))}" y="${f1(Y(gy-.12))}" width="${f1(W*sc)}" height="${f1(.26*sc)}" fill="rgba(255,255,255,.4)"/>`;

if(S.monture==='clos'){
o+=`<polygon points="${P([[-W/2-.55,gy-.42],[W/2+.55,gy-.42],[W*.22,-ro+.15],[-W*.22,-ro+.15]])}" fill="${gold}" stroke="rgba(0,0,0,.28)" stroke-width=".7"/>`;
o+=ln(-W/2-.55,gy-.42,W/2+.55,gy-.42,'rgba(255,255,255,.5)',1);
}else{
const pw=f1(.85*sc),mid=(-ro+gy)/2;
for(const sg of[-1,1]){
o+=`<path d="M${f1(X(sg*W*.36))} ${f1(Y(-ro+.15))}Q${f1(X(sg*W*.62))} ${f1(Y(mid))} ${f1(X(sg*(W/2+.05)))} ${f1(Y(gy-.1))}L${f1(X(sg*(W/2-.2)))} ${f1(Y(gy-ch*.38))}" fill="none" stroke="${gold}" stroke-width="${pw}" stroke-linecap="round" stroke-linejoin="round"/>`;
}
o+=`<path d="M${f1(X(0))} ${f1(Y(-ro+.1))}L${f1(X(0))} ${f1(Y(gy+.3))}" fill="none" stroke="${gold}" stroke-width="${f1(.9*sc)}" stroke-linecap="round"/>`;
}

if(S.monture==='halo'){
const n=Math.max(2,Math.floor((W-.4)/1.15)+1);
for(let i=0;i<n;i++){const x=(i-(n-1)/2)*1.15;
o+=`<circle cx="${f1(X(x))}" cy="${f1(Y(gy+.55))}" r="${f1(.5*sc)}" fill="${dia}" ${dotStroke}/>`;}
}

if(S.monture==='trois'){
const ds=Math.min(4.4,Math.max(2.4,W*.55)),y2=gy+.9;
const em=S.lat==='emeraude';
for(const sg of[-1,1])o+=gem(sg*(W/2+.85+ds/2),y2,ds,ds*.26,ds*.42,em?p+'ec':p+'d',em?p+'ep':p+'d');
}

return `<svg viewBox="0 0 420 420" role="img" aria-label="Vue de face de la bague">${o}</svg>`;
}

function goldGrams(S){
const J=JONCS[S.jonc],M=METALS[S.metal],ri=S.taille/TAU,{W}=dims(S.forme,S.carats);
const v=J.w*J.t*TAU*(ri+J.t/2);
return v*M.d/1000+MONT[S.monture].head*Math.pow(W/6,1.5);
}

function hash(str){let x=0;for(let i=0;i<str.length;i++)x=(x*31+str.charCodeAt(i))>>>0;return x.toString(36).toUpperCase().padStart(6,'0');}

function describe(S){
const sh=SHAPES[S.forme],{W,L}=dims(S.forme,S.carats),J=JONCS[S.jonc],mt=MONT[S.monture];
const nb=' ';
const dia=[];
if(S.monture==='halo')dia.push(HALO_RANGS[S.haloRang==='double'?'double':'simple'].n);
if(S.cache&&S.monture!=='clos')dia.push('halo caché sous la pierre');
if(S.monture==='trois'&&S.lat==='diamant')dia.push('pierres latérales');
if(S.alliance==='pavee')dia.push('alliance pavée');
if(S.pave)dia.push(PAVE_ETENDUES[PAVE_ETENDUES[S.paveEtendue]?S.paveEtendue:'demi'].n);
const rows=[['Pierre',`Émeraude ${sh.t}, environ ${fm(S.carats)}${nb}ct (≈${nb}${fm(L,1)}${nb}×${nb}${fm(W,1)}${nb}mm), ${(TINTS[S.teinte]||TINTS.vivid).d}`]];
if(S.ref)rows.push(['Référence de la pierre',S.ref]);
const latF=LAT_FORMES[S.latForme]?S.latForme:'rond',latT=LAT_TAILLES[S.latTaille]?S.latTaille:'moyenne';
const latTxt=S.monture==='trois'?`, pierres latérales en ${S.lat==='emeraude'?'émeraude':'diamant'}, taille ${LAT_FORMES[latF].n}, ${LAT_TAILLES[latT].n}`:'';
const tenue=S.monture==='clos'?'':`, ${GRIFFES[griffesOf(S)].n}`;
rows.push(['Monture',mt.n+latTxt+tenue+`, ${HAUTEURS[S.hauteur==='haute'?'haute':'basse'].n}`]);
rows.push(['Or',METALS[S.metal].n]);
rows.push(['Jonc',`${J.n}, ${fm(J.w,1)}${nb}mm, ${PROFILS[PROFILS[S.profil]?S.profil:'bombe'].n}`]);
rows.push(['Diamants',dia.length?`${dia.join(', ')}, ${S.origine==='syn'?'de synthèse':'naturels'}`:'Aucun']);
if(ALLIANCES[S.alliance]&&S.alliance!=='aucune')rows.push(['Alliance',ALLIANCES[S.alliance].n]);
rows.push(['Taille de doigt',S.tailleInc?'à déterminer':String(S.taille)]);
if(S.gravure)rows.push(['Gravure intérieure',`${S.gravure} (écriture ${POLICES[POLICES[S.police]?S.police:'classique'].n})`]);
rows.push(["Poids d'or estimé",`environ ${fm(goldGrams(S),1)}${nb}g (indicatif)`]);
const code='B-'+hash(JSON.stringify([S.forme,S.carats,S.teinte,S.monture,S.lat,S.metal,S.jonc,S.pave,S.origine,S.taille,S.tailleInc,S.ref,S.gravure,S.haloRang||'simple',S.paveEtendue||'demi',Boolean(S.cache),griffesOf(S),S.latForme||'rond',S.latTaille||'moyenne',S.profil||'bombe',S.hauteur||'basse',S.alliance||'aucune',S.police||'classique']));
const text=`Bague sur mesure Johya, réf.${nb}${code}\n`+rows.map(r=>r[0]+nb+': '+r[1]).join('\n');
return{rows,code,text,dia:dia.length>0};
}

;
/* i18n-core.js */
var JA_LOC=String(window.JOHYA_ATELIER_LOCALE||'fr').slice(0,2);
var JA_DICT=window.JOHYA_ATELIER_I18N||{};
var JA_T=function(s){return Object.prototype.hasOwnProperty.call(JA_DICT,s)?JA_DICT[s]:s;};
var JA_NUM=function(n,d){d=d===undefined?2:d;return JA_LOC==='en'?n.toFixed(d):n.toFixed(d).replace('.',',');};
if(JA_LOC!=='fr'){
  [SHAPES,METALS,TINTS,HALO_RANGS,PAVE_ETENDUES,GRIFFES,LAT_FORMES,LAT_TAILLES,PROFILS,HAUTEURS,ALLIANCES,POLICES,JONCS,MONT].forEach(function(table){
    Object.keys(table).forEach(function(key){['n','t','s','d'].forEach(function(field){if(typeof table[key][field]==='string')table[key][field]=JA_T(table[key][field]);});});
  });
  var JA_topView=topView,JA_faceView=faceView,JA_describe=describe;
  topView=function(S){return JA_topView(S).replace('Vue de dessus de la bague',JA_T('Vue de dessus de la bague'));};
  faceView=function(S){return JA_faceView(S).replace('Vue de face de la bague',JA_T('Vue de face de la bague'));};
  describe=function(S){
    var base=JA_describe(S),es=JA_LOC==='es',nb=' ';
    var sh=SHAPES[S.forme],d=dims(S.forme,S.carats),J=JONCS[S.jonc],mt=MONT[S.monture];
    var dia=[];
    if(S.monture==='halo')dia.push(HALO_RANGS[S.haloRang==='double'?'double':'simple'].n);
    if(S.cache&&S.monture!=='clos')dia.push(JA_T('halo caché sous la pierre'));
    if(S.monture==='trois'&&S.lat==='diamant')dia.push(JA_T('pierres latérales'));
    if(S.alliance==='pavee')dia.push(JA_T('alliance pavée'));
    if(S.pave)dia.push(PAVE_ETENDUES[PAVE_ETENDUES[S.paveEtendue]?S.paveEtendue:'demi'].n);
    var tint=(TINTS[S.teinte]||TINTS.vivid).d;
    var size=JA_NUM(d.L,1)+nb+'×'+nb+JA_NUM(d.W,1)+nb+'mm';
    var rows=[[JA_T('Pierre'),es?'Esmeralda '+sh.t+', unos '+JA_NUM(S.carats)+nb+'ct (≈'+nb+size+'), '+tint:'Emerald, '+sh.t+', approx. '+JA_NUM(S.carats)+nb+'ct (≈'+nb+size+'), '+tint]];
    if(S.ref)rows.push([JA_T('Référence de la pierre'),S.ref]);
    var latF=LAT_FORMES[S.latForme]?S.latForme:'rond',latT=LAT_TAILLES[S.latTaille]?S.latTaille:'moyenne';
    var emerald=S.lat==='emeraude';
    var latTxt=S.monture!=='trois'?'':(es?', piedras laterales de '+(emerald?'esmeralda':'diamante')+', forma '+LAT_FORMES[latF].n+', '+LAT_TAILLES[latT].n:', '+(emerald?'emerald':'diamond')+' side stones, '+LAT_FORMES[latF].n+' shape, '+LAT_TAILLES[latT].n);
    var tenue=S.monture==='clos'?'':', '+GRIFFES[griffesOf(S)].n;
    rows.push([JA_T('Monture'),mt.n+latTxt+tenue+', '+HAUTEURS[S.hauteur==='haute'?'haute':'basse'].n]);
    rows.push([JA_T('Or'),METALS[S.metal].n]);
    rows.push([JA_T('Jonc'),J.n+', '+JA_NUM(J.w,1)+nb+'mm, '+PROFILS[PROFILS[S.profil]?S.profil:'bombe'].n]);
    rows.push([JA_T('Diamants'),dia.length?dia.join(', ')+', '+(S.origine==='syn'?(es?'de síntesis':'lab-grown'):(es?'naturales':'natural')):(es?'Ninguno':'None')]);
    if(ALLIANCES[S.alliance]&&S.alliance!=='aucune')rows.push([JA_T('Alliance'),ALLIANCES[S.alliance].n]);
    rows.push([JA_T('Taille de doigt'),S.tailleInc?(es?'por determinar':'to be confirmed'):String(S.taille)]);
    var police=POLICES[POLICES[S.police]?S.police:'classique'].n;
    if(S.gravure)rows.push([JA_T('Gravure intérieure'),S.gravure+(es?' (letra '+police+')':' ('+police+' lettering)')]);
    rows.push([JA_T("Poids d'or estimé"),(es?'unos ':'approx. ')+JA_NUM(goldGrams(S),1)+nb+'g'+(es?' (orientativo)':' (indicative)')]);
    var text=(es?'Anillo a medida Johya, ref.':'Johya bespoke ring, ref.')+nb+base.code+'\n'+rows.map(function(r){return r[0]+': '+r[1];}).join('\n');
    return {rows:rows,code:base.code,text:text,dia:base.dia};
  };
}

;
/* gem-optics.js */
/* JOHYA 3.0: faceted optics for the centre stone AND instanced diamond melee.
 * This is a visual approximation, not a spectral/gemmological simulation.
 * Optional procedural veils describe a generic stone, never a photographed stock item.
 */
const GemOptics=(()=>{
  const T=typeof THREE!=='undefined'?THREE:null;if(!T)return{};
  const MAX_PLANES=192;
  const vertexShader=`
    uniform vec3 uCameraLocal;
    uniform mat3 uWorldRotation;
    varying vec3 vLocalPosition;
    varying vec3 vLocalNormal;
    varying vec3 vCameraLocal;
    varying mat3 vWorldRotation;
    mat3 transpose3(mat3 m){return mat3(vec3(m[0][0],m[1][0],m[2][0]),vec3(m[0][1],m[1][1],m[2][1]),vec3(m[0][2],m[1][2],m[2][2]));}
    void main(){
      vLocalPosition=position;vLocalNormal=normal;
      #ifdef USE_INSTANCING
        mat3 basis=mat3(instanceMatrix);
        // The viewer uses only uniform positive scales for melee instances.
        float scale2=max(dot(basis[0],basis[0]),0.000001);
        vCameraLocal=transpose3(basis)*(uCameraLocal-instanceMatrix[3].xyz)/scale2;
        vWorldRotation=uWorldRotation*basis;
        gl_Position=projectionMatrix*modelViewMatrix*instanceMatrix*vec4(position,1.0);
      #else
        vCameraLocal=uCameraLocal;vWorldRotation=uWorldRotation;
        gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0);
      #endif
    }
  `;
  const fragmentShader=`
    precision highp float;
    uniform samplerCube uEnv;
    uniform vec4 uPlanes[__PLANES__];
    uniform vec3 uAbsorption;
    uniform float uSize;
    uniform float uIor;
    uniform float uExposure;
    uniform float uVeils;
    uniform float uDiamond;
    uniform float uReflect;
    uniform float uBody;
    varying vec3 vLocalPosition;
    varying vec3 vLocalNormal;
    varying vec3 vCameraLocal;
    varying mat3 vWorldRotation;
    vec3 environment(vec3 d){return textureCube(uEnv,normalize(vWorldRotation*d)).rgb*uExposure;}
    float fresnel(float c,float eta){float f=(eta-1.0)/(eta+1.0);f*=f;return f+(1.0-f)*pow(1.0-clamp(c,0.0,1.0),5.0);}
    // A low-amplitude volume modulation, stable in object coordinates. No surface scratch decal.
    float veil(vec3 p){
      vec3 q=p/uSize;
      float n=sin(q.x*19.0+sin(q.z*12.0))*sin(q.y*15.0+q.z*7.0);
      float sheet=exp(-abs(q.y+q.x*.24+sin(q.z*17.0)*.016+.20)*90.0);
      return clamp(.35+.3*n+.35*sheet,0.0,1.0);
    }
    void main(){
      vec3 N=normalize(vLocalNormal),I=normalize(vLocalPosition-vCameraLocal);
      float f=fresnel(dot(-I,N),uIor);
      vec3 result=environment(reflect(I,N))*f*uReflect;
      vec3 direction=refract(I,N,1.0/uIor);
      vec3 position=vLocalPosition+direction*(uSize*.00025);
      vec3 throughput=vec3(1.0-f)*exp(-uAbsorption*uBody);
      for(int bounce=0;bounce<__BOUNCES__;bounce++){
        float nearest=1.0e8;vec3 exitNormal=N;
        for(int j=0;j<__PLANES__;j++){
          vec4 plane=uPlanes[j];float denom=dot(plane.xyz,direction);
          if(denom>.00005){float distance=(plane.w-dot(plane.xyz,position))/denom;
            if(distance>uSize*.00004&&distance<nearest){nearest=distance;exitNormal=plane.xyz;}
          }
        }
        if(nearest>1.0e7){result+=throughput*environment(direction)*.5;throughput=vec3(0.0);break;}
        float density=1.0+uVeils*(veil(position+direction*nearest*.5)-.5);
        throughput*=exp(-uAbsorption*nearest/uSize*density);
        position+=direction*nearest;
        vec3 outgoing=refract(direction,-exitNormal,uIor);
        float hasExit=step(.01,length(outgoing));
        float insideF=fresnel(dot(direction,exitNormal),uIor);
        float transmission=hasExit*(1.0-insideF);
        if(hasExit>.5)result+=throughput*transmission*environment(outgoing);
        throughput*=1.0-transmission;
        direction=reflect(direction,exitNormal);position+=direction*(uSize*.00025);
      }
      // Bounded residual approximation for paths that exceed the realtime bounce budget.
      result+=throughput*environment(direction)*.38;
      result=max(result,vec3(0.0));
      // Hue-preserving tone curve for coloured stones: the brightest channel is compressed and the others follow,
      // so thin paths stay emerald green instead of drifting to mint or yellow-white; the .86 shoulder keeps flashes below fluorescent green. Diamonds keep the scene curve.
      if(uDiamond<.5){float peak=max(max(result.r,result.g),result.b);result*=peak>.0001?.86*(1.0-exp(-peak*1.7))/peak:0.0;}
      gl_FragColor=vec4(result,1.0);
      if(uDiamond>.5){
      #include <tonemapping_fragment>
      }
      #include <colorspace_fragment>
    }
  `;
  function planesFor(geometry){
    const flat=geometry.index?geometry.toNonIndexed():geometry;
    const p=flat.attributes.position,out=[];
    const a=new T.Vector3(),b=new T.Vector3(),c=new T.Vector3(),n=new T.Vector3(),ab=new T.Vector3(),ac=new T.Vector3();
    // Relative tolerances are needed for 1 mm melee as well as the central stone.
    geometry.computeBoundingBox();const size=geometry.boundingBox.getSize(new T.Vector3()).length(),eps=Math.max(.00001,size*.00004);
    for(let i=0;i<p.count;i+=3){
      a.fromBufferAttribute(p,i);b.fromBufferAttribute(p,i+1);c.fromBufferAttribute(p,i+2);
      n.crossVectors(ab.subVectors(b,a),ac.subVectors(c,a)).normalize();if(n.lengthSq()<.5)continue;
      const d=n.dot(a);
      if(out.some(q=>q.x*n.x+q.y*n.y+q.z*n.z>.99999&&Math.abs(q.w-d)<eps))continue;
      let supported=true;
      for(let k=0;k<p.count;k++)if(n.x*p.getX(k)+n.y*p.getY(k)+n.z*p.getZ(k)>d+eps){supported=false;break;}
      if(supported)out.push(new T.Vector4(n.x,n.y,n.z,d));
    }
    if(flat!==geometry)flat.dispose();
    if(out.length<4||out.length>MAX_PLANES)throw new Error('Invalid convex gem plane count: '+out.length);
    return {planes:out,count:out.length};
  }
  // Per-channel absorption (red, green, blue) for each shade of the site.
  // Calibrated on 29/10/2026 against the site's shade photos (mean colour of the stone centre, 'pierre' view),
  // under assets/studio.hdr, reflect .12, body .8 and the hue-preserving tone curve (scripts/calibrer-nuances.py).
  const ABSORB={transparent:[0.167,0.021,0.005],clair:[0.965,0.126,0.438],vivid:[3.445,0.095,0.741],muzo:[4.155,0.565,1.336],chivor:[2.023,0.104,0.417],coscuez:[2.529,0.329,0.989],intense:[3.88,0.398,1.034],profond:[80.0,1.599,2.29]};
  ABSORB.vif=ABSORB.vivid;ABSORB.bleute=ABSORB.chivor;
  const SETTINGS={exposure:.85,reflect:.12,body:.8};
  const EXPOSURE={transparent:2.0,clair:1.4};
  function material(geometry,environment,tint='vif',size=6,diamond=false,options={}){
    const {planes,count}=planesFor(geometry);
    const absorb=diamond?[.010,.009,.007]:(ABSORB[tint]||ABSORB.vivid);
    const bounces=options.melee?4:5;
    const mat=new T.ShaderMaterial({vertexShader,fragmentShader:fragmentShader.replaceAll('__PLANES__',String(count)).replaceAll('__BOUNCES__',String(bounces)),toneMapped:true,uniforms:{
      uEnv:{value:environment},uPlanes:{value:planes},uCameraLocal:{value:new T.Vector3()},uWorldRotation:{value:new T.Matrix3()},
      uAbsorption:{value:new T.Vector3(...absorb)},uSize:{value:Math.max(.01,size)},uIor:{value:diamond?2.417:1.57},uExposure:{value:diamond?1.02:(EXPOSURE[tint]||SETTINGS.exposure)},
      uVeils:{value:diamond?0:.16},uDiamond:{value:diamond?1:0},uReflect:{value:diamond?1:SETTINGS.reflect},uBody:{value:diamond?0:SETTINGS.body}
    }});
    mat.userData={planeCount:count,bounces,visualApproximation:true};return mat;
  }
  function attach(mesh){
    const inverse=new T.Matrix4(),cameraPosition=new T.Vector3();
    mesh.onBeforeRender=(_r,_s,camera)=>{
      const u=mesh.material.uniforms;inverse.copy(mesh.matrixWorld).invert();camera.getWorldPosition(cameraPosition);
      u.uCameraLocal.value.copy(cameraPosition).applyMatrix4(inverse);u.uWorldRotation.value.setFromMatrix4(mesh.matrixWorld);
      mesh.material.uniformsNeedUpdate=true;
    };return mesh;
  }
  return{material,attach,planesFor,ABSORB,SETTINGS,EXPOSURE};
})();

;
/* ring3d.js */
/* JOHYA visual revision 3.0.0 - 2026-10-13. Procedural study, not a manufacturing CAD. */
const Ring3D=(()=>{
const T=typeof THREE!=='undefined'?THREE:null;
const TAU=Math.PI*2;
// 18 ct alloys: base reflectance, polish and environment response are set per alloy, never shared.
const GOLD3D={
  jaune:{color:'#e3b764',roughness:.2,envMapIntensity:1.08,satin:.26},
  blanc:{color:'#dcdee2',roughness:.15,envMapIntensity:1.12,satin:.22},
  rose:{color:'#e2a585',roughness:.21,envMapIntensity:1.05,satin:.27}
};
let R,scene,cam,host,diaGeo,starTex,glowTex,shadow,group,burst,stoneMat,raf=0,visible=true;
let sparks=[],owned=[];
const V={yaw:.38,pitch:.68,dist:70,ty:3,tyaw:.38,tpitch:.68,tdist:70,tty:3};
let mode='angle',auto=true,lastInput=0,fit={hh:16,ww:14,cy:3},popAt=0,flashAt=-9,reduce=false,viewCb=null,prevT=0,clock0=0;
let dirty=true, presentationPhase=0, envPMREM=null, geometryStats=null;
let studioReady=false, lastS=null, envCube=null, envTarget=null, resizeObserver=null, intersection=null, intersecting=true, motionQuery=null, paused=false, userZoom=1, dark=false;

const easeOutBack=x=>{const c1=1.70158,c3=c1+1;return 1+c3*Math.pow(x-1,3)+c1*Math.pow(x-1,2);};
const easeOutCubic=x=>1-Math.pow(1-x,3);

function orient(geo,cy){
const p=geo.attributes.position;
for(let i=0;i<p.count;i+=3){
const ax=p.getX(i),ay=p.getY(i),az=p.getZ(i);
const bx=p.getX(i+1),by=p.getY(i+1),bz=p.getZ(i+1);
const cx=p.getX(i+2),cyy=p.getY(i+2),cz=p.getZ(i+2);
const ux=bx-ax,uy=by-ay,uz=bz-az,vx=cx-ax,vy=cyy-ay,vz=cz-az;
const nx=uy*vz-uz*vy,ny=uz*vx-ux*vz,nz=ux*vy-uy*vx;
const mx=(ax+bx+cx)/3,my=(ay+by+cyy)/3-cy,mz=(az+bz+cz)/3;
if(nx*mx+ny*my+nz*mz<0){p.setXYZ(i+1,cx,cyy,cz);p.setXYZ(i+2,bx,by,bz);}
}
p.needsUpdate=true;
geo.computeVertexNormals();
return geo;
}

function loft(rings,capBottom,capTop,cy){
const pos=[];
const push=(a,b,c)=>{pos.push(a[0],a[1],a[2],b[0],b[1],b[2],c[0],c[1],c[2]);};
const n=rings[0].pts.length;
for(let i=0;i<rings.length-1;i++){
const A=rings[i],B=rings[i+1];
for(let k=0;k<n;k++){
const k2=(k+1)%n;
const a=[A.pts[k][0],A.y,A.pts[k][1]],b=[A.pts[k2][0],A.y,A.pts[k2][1]];
const c=[B.pts[k2][0],B.y,B.pts[k2][1]],d=[B.pts[k][0],B.y,B.pts[k][1]];
push(a,b,c);push(a,c,d);
}}
const cap=(r)=>{
let sx=0,sz=0;for(const q of r.pts){sx+=q[0];sz+=q[1];}
const c=[sx/n,r.y,sz/n];
for(let k=0;k<n;k++){const k2=(k+1)%n;push(c,[r.pts[k][0],r.y,r.pts[k][1]],[r.pts[k2][0],r.y,r.pts[k2][1]]);}
};
if(capBottom)cap(rings[0]);
if(capTop)cap(rings[rings.length-1]);
const g=new T.BufferGeometry();
g.setAttribute('position',new T.Float32BufferAttribute(pos,3));
return orient(g,cy);
}

function outline(shape,w,h){
  if(shape==='trapeze'){const a=w/2,b=h/2;return[[-a,-b],[a,-b],[a*.6,b],[-a*.6,b]];}
  if(shape==='baguette'){const a=w/2,b=h/2,c=Math.min(w,h)*.08;return[[-a+c,-b],[a-c,-b],[a,-b+c],[a,b-c],[a-c,b],[-a+c,b],[-a,b-c],[-a,-b+c]];}
  if(shape==='poire')return sample(shape,w,h).map(q=>[-q[0],-q[1]]);
  if(shape!=='emeraude')return sample(shape,w,h);
  const a=w/2,b=h/2,c=Math.min(w,h)*.115;
  return[[-a+c,-b],[a-c,-b],[a,-b+c],[a,b-c],[a-c,b],[-a+c,b],[-a,b-c],[-a,-b+c]];
}
function stoneGeo(shape,W,L,D){
  if(shape==='emeraude'||shape==='baguette'){
    const step=(width,y)=>({pts:outline(shape,width,L-(W-width)),y});
    return loft([
      step(W*.025,-D*.72),step(W*.40,-D*.49),step(W*.73,-D*.265),
      step(W,-D*.01),step(W,D*.01),step(W*.90,D*.125),step(W*.71,D*.28)
    ],true,true,-D*.12);
  }
  if(shape==='trapeze'){
    const base=outline(shape,W,L),sc=k=>base.map(q=>[q[0]*k,q[1]*k]);
    return loft([{pts:sc(.035),y:-D*.72},{pts:sc(.42),y:-D*.49},{pts:sc(.74),y:-D*.265},{pts:sc(1),y:-D*.01},{pts:sc(1),y:D*.01},{pts:sc(.90),y:D*.125},{pts:sc(.71),y:D*.28}],true,true,-D*.12);
  }
  const key=shape+':'+(L/W).toFixed(3)+':'+(D/W).toFixed(3);
  if(!hullCache[key])hullCache[key]=brilliantGeo(shape,L/W,D/W);
  const g=hullCache[key].clone();g.scale(W,W,W);return g;
}
const hullCache={};
function hullGeo(points){
  // Convex hull by plane enumeration; coplanar vertices are merged into a single polished facet.
  const n=points.length,X=points.map(p=>p[0]),Y=points.map(p=>p[1]),Z=points.map(p=>p[2]);
  const size=Math.hypot(Math.max(...X)-Math.min(...X),Math.max(...Y)-Math.min(...Y),Math.max(...Z)-Math.min(...Z)),eps=size*2e-5;
  const seen=new Set(),faces=[];
  for(let i=0;i<n;i++)for(let j=i+1;j<n;j++)for(let k=j+1;k<n;k++){
    const ux=X[j]-X[i],uy=Y[j]-Y[i],uz=Z[j]-Z[i],vx=X[k]-X[i],vy=Y[k]-Y[i],vz=Z[k]-Z[i];
    let nx=uy*vz-uz*vy,ny=uz*vx-ux*vz,nz=ux*vy-uy*vx;const l=Math.hypot(nx,ny,nz);
    if(l<size*size*1e-7)continue;nx/=l;ny/=l;nz/=l;let d=nx*X[i]+ny*Y[i]+nz*Z[i],lo=0,hi=0;
    for(let q=0;q<n;q++){const v=nx*X[q]+ny*Y[q]+nz*Z[q]-d;if(v<lo)lo=v;else if(v>hi)hi=v;if(lo<-eps&&hi>eps)break;}
    if(lo<-eps&&hi>eps)continue;
    if(hi>eps){nx=-nx;ny=-ny;nz=-nz;d=-d;}
    const on=[];for(let q=0;q<n;q++)if(Math.abs(nx*X[q]+ny*Y[q]+nz*Z[q]-d)<eps*4)on.push(q);
    const key=on.join(',');if(seen.has(key))continue;seen.add(key);faces.push({m:new T.Vector3(nx,ny,nz),on});
  }
  const P=points.map(p=>new T.Vector3(...p)),pos=[];
  for(const {m,on} of faces){
    const c=on.reduce((a,q)=>a.add(P[q]),new T.Vector3()).divideScalar(on.length);
    const u=P[on[0]].clone().sub(c).normalize(),v=new T.Vector3().crossVectors(m,u),w=new T.Vector3();
    const angle=q=>{w.subVectors(P[q],c);return Math.atan2(v.dot(w),u.dot(w));};
    const ring=on.slice().sort((a,b)=>angle(a)-angle(b));
    for(let t=1;t<ring.length-1;t++)pos.push(...P[ring[0]].toArray(),...P[ring[t]].toArray(),...P[ring[t+1]].toArray());
  }
  const g=new T.BufferGeometry();g.setAttribute('position',new T.Float32BufferAttribute(pos,3));g.computeVertexNormals();return g;
}
function brilliantGeo(shape,ratio,depth){
  // Modified brilliant at unit width: table, 8 stars, 8 bezels, upper and lower girdle facets, 8 pavilion mains.
  // The proportions follow the former step model (crown .28 D, pavilion .72 D) so prongs keep their seats.
  const W=1,L=ratio,D=depth,raw=outline(shape,W,L),N=32;
  const len=[0];for(let i=1;i<=raw.length;i++){const a=raw[i-1],b=raw[i%raw.length];len.push(len[i-1]+Math.hypot(b[0]-a[0],b[1]-a[1]));}
  const total=len[raw.length],G=[];
  for(let j=0;j<N;j++){
    const at=total*j/N;let i=0;while(len[i+1]<at)i++;
    const a=raw[i],b=raw[(i+1)%raw.length],f=(at-len[i])/(len[i+1]-len[i]||1);G.push([a[0]+(b[0]-a[0])*f,a[1]+(b[1]-a[1])*f]);
  }
  const cx=G.reduce((a,q)=>a+q[0],0)/N,cz=G.reduce((a,q)=>a+q[1],0)/N;
  const at=(j,f)=>[cx+(G[j%N][0]-cx)*f,cz+(G[j%N][1]-cz)*f];
  const gt=D*.012,crown=D*.28,pav=D*.72,table=.56,pts=[];
  const crownY=f=>gt+(crown-gt)*(1-f)/(1-table),pavY=f=>-gt-(pav-gt)*(1-f);
  for(const q of G){pts.push([q[0],gt,q[1]],[q[0],-gt,q[1]]);}
  for(let k=0;k<8;k++){
    const t=at(4*k,table),st=at(4*k+2,.78),lg=at(4*k+2,.80);
    pts.push([t[0],crown,t[1]],[st[0],crownY(.78)+crown*.04,st[1]],[lg[0],pavY(.80)-pav*.03,lg[1]]);
  }
  pts.push([cx,-pav,cz]);
  return hullGeo(pts);
}

function circlePts(n,r,ph){
const a=[];for(let i=0;i<n;i++){const t=(i+ph)/n*TAU;a.push([r*Math.cos(t),r*Math.sin(t)]);}return a;
}

function makeDiamond(){
const n=16;
const rings=[
{pts:circlePts(n,.025,0),y:-.43},
{pts:circlePts(n,.27,.5),y:-.22},
{pts:circlePts(n,.5,0),y:-.012},
{pts:circlePts(n,.5,0),y:.012},
{pts:circlePts(n,.41,.5),y:.075},
{pts:circlePts(n,.285,0),y:.16}
];
return loft(rings,true,true,0);
}

function bandGeo(ri,ro,w,profil='bombe',gap=0){
  // Half-round comfort section: domed outside, a gently rounded and flatter inner face, tapered shoulders.
  // profil 'plat' squares the section; gap opens the top for a split shank.
  const N=192,P=32,pos=[],idx=[];
  const thickness=ro-ri,flat=profil==='plat',open=gap>0;
  const th0=open?Math.PI/2+gap:0,span=open?TAU-2*gap:TAU;
  for(let i=0;i<=N;i++){
    const th=th0+i/N*span,c=Math.cos(th),sn=Math.sin(th);
    const taper=open?1:1-.23*Math.pow(Math.max(0,sn),8);
    for(let j=0;j<P;j++){
      const a=j/P*TAU,ca=Math.cos(a),sa=Math.sin(a);
      const radial=thickness*.5*(flat?Math.sign(ca)*Math.pow(Math.abs(ca),.32):ca>=0?ca:-Math.pow(-ca,.45));
      const z=w*.5*taper*Math.sign(sa)*Math.pow(Math.abs(sa),flat?.3:.86);
      const r=ri+thickness*.5+radial;
      pos.push(r*c,r*sn,z);
    }
  }
  for(let i=0;i<N;i++)for(let j=0;j<P;j++){
    const a=i*P+j,b=i*P+(j+1)%P,c=(i+1)*P+(j+1)%P,d=(i+1)*P+j;
    idx.push(a,c,b,a,d,c);
  }
  if(open){
    // Fan caps on the two cut ends, hidden inside the split strands.
    for(const i of[0,N]){
      const th=th0+i/N*span,rc=ri+thickness*.5,centre=pos.length/3;pos.push(rc*Math.cos(th),rc*Math.sin(th),0);
      for(let j=0;j<P;j++)idx.push(centre,i*P+j,i*P+(j+1)%P);
    }
  }
  const g=new T.BufferGeometry();g.setAttribute('position',new T.Float32BufferAttribute(pos,3));g.setIndex(idx);g.computeVertexNormals();
  if(open)return g;
  // Weld the periodic lighting seam (positions remain indexed for the closed surface).
  const normals=g.attributes.normal;
  for(let j=0;j<P;j++){
    const v=new T.Vector3().fromBufferAttribute(normals,j).add(new T.Vector3().fromBufferAttribute(normals,N*P+j)).normalize();
    normals.setXYZ(j,v.x,v.y,v.z);normals.setXYZ(N*P+j,v.x,v.y,v.z);
  }
  normals.needsUpdate=true;
  return g;
}
function taperedWire(points,r0,r1,segments=32,radial=10){
  const curve=new T.CatmullRomCurve3(points.map(p=>p.isVector3?p:new T.Vector3(...p)));
  const frames=curve.computeFrenetFrames(segments,false),pos=[],idx=[];
  for(let i=0;i<=segments;i++){
    const t=i/segments,p=curve.getPointAt(t),r=r0+(r1-r0)*(t*t*(3-2*t));
    for(let j=0;j<radial;j++){
      const a=j/radial*TAU,q=p.clone().addScaledVector(frames.normals[i],Math.cos(a)*r).addScaledVector(frames.binormals[i],Math.sin(a)*r);pos.push(q.x,q.y,q.z);
    }
  }
  for(let i=0;i<segments;i++)for(let j=0;j<radial;j++){
    const a=i*radial+j,b=i*radial+(j+1)%radial,c=(i+1)*radial+(j+1)%radial,d=(i+1)*radial+j;idx.push(a,d,b,b,d,c);
  }
  const g=new T.BufferGeometry();g.setAttribute('position',new T.Float32BufferAttribute(pos,3));g.setIndex(idx);g.computeVertexNormals();return g;
}
function contourTube(points,y,r){
  // Linear corner preservation; Catmull-Rom over eight points would round an emerald cut.
  const curve=new T.CurvePath();
  for(let i=0;i<points.length;i++){
    const a=points[i],b=points[(i+1)%points.length];
    curve.add(new T.LineCurve3(new T.Vector3(a[0],y,a[1]),new T.Vector3(b[0],y,b[1])));
  }
  return new T.TubeGeometry(curve,Math.max(160,points.length*3),r,10,true);
}
function bezelGeo(shape,W,L,gy,D){
  // Hollow, gently tapered bezel. No solid funnel or pedestal below the emerald.
  const outer=outline(shape,W+.62,L+.62),inner=outline(shape,W-.06,L-.06);
  const rings=[
    {pts:outer.map(q=>[q[0]*.71,q[1]*.71]),y:gy-D*.47},
    {pts:outer.map(q=>[q[0]*.91,q[1]*.91]),y:gy-D*.15},
    {pts:outer,y:gy+.055},
    {pts:inner,y:gy+.07},
    {pts:inner.map(q=>[q[0]*.94,q[1]*.94]),y:gy-D*.12},
    {pts:inner.map(q=>[q[0]*.71,q[1]*.71]),y:gy-D*.47}
  ];
  // Walls are deliberately hollow. Winding is prescribed instead of orient() for inner normals.
  const pos=[],n=outer.length;
  for(let k=0;k<rings.length;k++){
    const A=rings[k],B=rings[(k+1)%rings.length];
    for(let i=0;i<n;i++){
      const j=(i+1)%n,a=[A.pts[i][0],A.y,A.pts[i][1]],b=[A.pts[j][0],A.y,A.pts[j][1]],c=[B.pts[j][0],B.y,B.pts[j][1]],d=[B.pts[i][0],B.y,B.pts[i][1]];
      pos.push(...a,...c,...b,...a,...d,...c);
    }
  }
  const g=new T.BufferGeometry();g.setAttribute('position',new T.Float32BufferAttribute(pos,3));g.computeVertexNormals();return g;
}

function starTexture(){
const c=document.createElement('canvas');c.width=c.height=128;
const x=c.getContext('2d');
const g=x.createRadialGradient(64,64,0,64,64,64);
g.addColorStop(0,'rgba(255,255,255,1)');g.addColorStop(.12,'rgba(255,255,255,.85)');g.addColorStop(.35,'rgba(255,255,255,.12)');g.addColorStop(1,'rgba(255,255,255,0)');
x.fillStyle=g;x.fillRect(0,0,128,128);
const ray=(rot,len,wd)=>{
x.save();x.translate(64,64);x.rotate(rot);
const lg=x.createLinearGradient(-len,0,len,0);
lg.addColorStop(0,'rgba(255,255,255,0)');lg.addColorStop(.5,'rgba(255,255,255,1)');lg.addColorStop(1,'rgba(255,255,255,0)');
x.fillStyle=lg;
x.beginPath();x.ellipse(0,0,len,wd,0,0,TAU);x.fill();
x.restore();
};
ray(0,62,2.2);ray(Math.PI/2,62,2.2);ray(Math.PI/4,34,1.4);ray(-Math.PI/4,34,1.4);
const t=new T.CanvasTexture(c);t.colorSpace=T.SRGBColorSpace;return t;
}

function glowTexture(){
const c=document.createElement('canvas');c.width=c.height=128;
const x=c.getContext('2d');
const g=x.createRadialGradient(64,64,0,64,64,64);
g.addColorStop(0,'rgba(0,0,0,.55)');g.addColorStop(.5,'rgba(0,0,0,.22)');g.addColorStop(1,'rgba(0,0,0,0)');
x.fillStyle=g;x.fillRect(0,0,128,128);
const t=new T.CanvasTexture(c);t.colorSpace=T.SRGBColorSpace;return t;
}

function bgTexture(){
const c=document.createElement('canvas');c.width=512;c.height=512;
const x=c.getContext('2d');
const g=x.createRadialGradient(256,200,20,256,256,420);
g.addColorStop(0,'#2a6a58');g.addColorStop(.45,'#18463a');g.addColorStop(1,'#071a15');
x.fillStyle=g;x.fillRect(0,0,512,512);
const t=new T.CanvasTexture(c);t.colorSpace=T.SRGBColorSpace;return t;
}

function makeEnv(){
  // Local high-dynamic-range softboxes. No stock photo/HDR dependency, no external request.
  const W=512,H=256,data=new Float32Array(W*H*4);
  const makeBox=(dir,w,h,power)=>{
    const f=new T.Vector3(...dir).normalize();
    const right=new T.Vector3().crossVectors(f,Math.abs(f.y)>.95?new T.Vector3(0,0,1):UP).normalize();
    return {f,r:right,u:new T.Vector3().crossVectors(right,f).normalize(),w,h,power};
  };
  const boxes=[makeBox([-4,6,7],.50,.72,3.2),makeBox([7,2,3],.12,.85,2.7),makeBox([0,9,-2],.54,.35,2.0),makeBox([-3,2,-8],.45,.64,2.1),makeBox([0,-7,4],.82,.52,.5)];
  const flag=makeBox([2,1,8],.13,.8,.88);
  const d=new T.Vector3();
  const energy=b=>{
    const z=d.dot(b.f);if(z<=0)return 0;
    const x=d.dot(b.r)/z/b.w,y=d.dot(b.u)/z/b.h;
    if(Math.abs(x)>2||Math.abs(y)>2)return 0;
    return Math.exp(-Math.pow(Math.abs(x),6)*1.5-Math.pow(Math.abs(y),6)*1.5);
  };
  for(let y=0;y<H;y++)for(let x=0;x<W;x++){
    const theta=(x+.5)/W*TAU,phi=(y+.5)/H*Math.PI;
    d.set(-Math.sin(phi)*Math.cos(theta),-Math.cos(phi),Math.sin(phi)*Math.sin(theta));
    let light=.26+.14*Math.max(0,d.y);
    for(const b of boxes)light+=energy(b)*b.power;
    light*=1-energy(flag)*flag.power;
    const i=(y*W+x)*4;data[i]=light;data[i+1]=light*.992;data[i+2]=light*.975;data[i+3]=1;
  }
  const texture=new T.DataTexture(data,W,H,T.RGBAFormat,T.FloatType);
  texture.mapping=T.EquirectangularReflectionMapping;texture.colorSpace=T.LinearSRGBColorSpace;texture.needsUpdate=true;
  texture.minFilter=T.LinearFilter;texture.magFilter=T.LinearFilter;
  envTarget=new T.WebGLCubeRenderTarget(256,{type:T.HalfFloatType,generateMipmaps:true,minFilter:T.LinearMipmapLinearFilter,magFilter:T.LinearFilter});
  envTarget.fromEquirectangularTexture(R,texture);texture.dispose();envCube=envTarget.texture;
  const pm=new T.PMREMGenerator(R);envPMREM=pm.fromCubemap(envCube);pm.dispose();return envPMREM.texture;
}

function parseHDR(buffer){
  const b=new Uint8Array(buffer);let i=0;
  const line=()=>{let t='';while(i<b.length&&b[i]!==10)t+=String.fromCharCode(b[i++]);i++;return t;};
  if(!line().startsWith('#?'))throw new Error('Not a Radiance HDR file');
  while(line()!=='');
  const m=line().match(/-Y (\d+) \+X (\d+)/);if(!m)throw new Error('Unsupported HDR orientation');
  const H=+m[1],W=+m[2],out=new Uint16Array(W*H*4),row=new Uint8Array(W*4),half=T.DataUtils.toHalfFloat,one=half(1);
  for(let y=0;y<H;y++){
    if(b[i]===2&&b[i+1]===2&&((b[i+2]<<8)|b[i+3])===W){
      i+=4;
      for(let c=0;c<4;c++){let x=0;while(x<W){let n=b[i++];if(n>128){n-=128;const v=b[i++];while(n--)row[(x++)*4+c]=v;}else while(n--)row[(x++)*4+c]=b[i++];}}
    }else{row.set(b.subarray(i,i+W*4));i+=W*4;}
    const o0=(H-1-y)*W*4;
    for(let x=0;x<W;x++){const e=row[x*4+3],f=e?Math.pow(2,e-136):0,o=o0+x*4;out[o]=half(row[x*4]*f);out[o+1]=half(row[x*4+1]*f);out[o+2]=half(row[x*4+2]*f);out[o+3]=one;}
  }
  return{data:out,width:W,height:H};
}
function loadStudio(){
  // The studio HDR arrives after the first frame; the procedural softboxes light the ring until then.
  const url=window.JOHYA_ATELIER_HDR||'assets/studio.hdr';
  fetch(url).then(r=>{if(!r.ok)throw new Error('HTTP '+r.status);return r.arrayBuffer();}).then(buffer=>{
    if(!R)return;
    const hdr=parseHDR(buffer),texture=new T.DataTexture(hdr.data,hdr.width,hdr.height,T.RGBAFormat,T.HalfFloatType);
    texture.mapping=T.EquirectangularReflectionMapping;texture.colorSpace=T.LinearSRGBColorSpace;texture.minFilter=texture.magFilter=T.LinearFilter;texture.needsUpdate=true;
    const target=new T.WebGLCubeRenderTarget(256,{type:T.HalfFloatType,generateMipmaps:true,minFilter:T.LinearMipmapLinearFilter,magFilter:T.LinearFilter});
    target.fromEquirectangularTexture(R,texture);texture.dispose();
    const pm=new T.PMREMGenerator(R),pmrem=pm.fromCubemap(target.texture);pm.dispose();
    envTarget?.dispose();envPMREM?.dispose();envTarget=target;envCube=target.texture;envPMREM=pmrem;scene.environment=pmrem.texture;
    group.traverse(o=>{const u=o.material?.uniforms;if(u?.uEnv)u.uEnv.value=envCube;});
    studioReady=true;dirty=true;
  }).catch(error=>console.warn('Studio HDR unavailable, procedural light kept:',error));
}
const contact={y:0,size:10,top:10,dirty:false};
function makeContact(){
  // Soft contact shadow: depth seen from under the ring, blurred twice, laid on a transparent plane.
  const c=contact,options={type:T.HalfFloatType};
  c.rt=new T.WebGLRenderTarget(512,512,options);c.rb=new T.WebGLRenderTarget(512,512,options);
  c.rt.texture.generateMipmaps=c.rb.texture.generateMipmaps=false;
  c.cam=new T.OrthographicCamera(-.5,.5,.5,-.5,0,1);c.cam.rotation.x=Math.PI/2;
  const darkness={value:1.35};
  c.depth=new T.MeshDepthMaterial();
  c.depth.onBeforeCompile=shader=>{shader.uniforms.darkness=darkness;shader.fragmentShader='uniform float darkness;\n'+shader.fragmentShader.replace('gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );','gl_FragColor = vec4( vec3( 1.0 ), pow( 1.0 - fragCoordZ, 2.0 ) * darkness );');};
  c.blur=new T.ShaderMaterial({uniforms:{tDiffuse:{value:null},dir:{value:new T.Vector2()}},depthTest:false,depthWrite:false,
    vertexShader:'varying vec2 vUv;void main(){vUv=uv;gl_Position=vec4(position.xy,0.,1.);}',
    fragmentShader:'uniform sampler2D tDiffuse;uniform vec2 dir;varying vec2 vUv;void main(){vec4 s=texture2D(tDiffuse,vUv)*.1633;s+=(texture2D(tDiffuse,vUv+dir)+texture2D(tDiffuse,vUv-dir))*.1531;s+=(texture2D(tDiffuse,vUv+dir*2.)+texture2D(tDiffuse,vUv-dir*2.))*.12245;s+=(texture2D(tDiffuse,vUv+dir*3.)+texture2D(tDiffuse,vUv-dir*3.))*.0918;s+=(texture2D(tDiffuse,vUv+dir*4.)+texture2D(tDiffuse,vUv-dir*4.))*.051;gl_FragColor=s;}'});
  c.quad=new T.Mesh(new T.PlaneGeometry(2,2),c.blur);c.quad.frustumCulled=false;
  c.qscene=new T.Scene();c.qscene.add(c.quad);c.qcam=new T.OrthographicCamera(-1,1,1,-1,0,1);
  c.mesh=new T.Mesh(new T.PlaneGeometry(1,1).rotateX(Math.PI/2),new T.MeshBasicMaterial({map:c.rt.texture,transparent:true,depthWrite:false,opacity:.42,color:'#3a2c14'}));
  c.mesh.renderOrder=1;scene.add(c.mesh);
}
function renderContact(){
  const c=contact,h=c.size/2;c.dirty=false;
  Object.assign(c.cam,{left:-h,right:h,top:h,bottom:-h,near:0,far:Math.max(1,c.top-c.y)});c.cam.position.set(0,c.y,0);c.cam.updateProjectionMatrix();c.cam.updateMatrixWorld();
  c.mesh.position.y=c.y;c.mesh.scale.set(c.size,-1,c.size);
  const hidden=[c.mesh,shadow,...sparks.map(k=>k.s)];hidden.forEach(o=>{o.userData.wasVisible=o.visible;o.visible=false;});
  const background=scene.background,clear=R.getClearAlpha();scene.background=null;scene.overrideMaterial=c.depth;
  R.setRenderTarget(c.rt);R.setClearColor(0x000000,0);R.clear();R.render(scene,c.cam);scene.overrideMaterial=null;scene.background=background;
  for(const amount of[2.4,1.1]){
    c.blur.uniforms.tDiffuse.value=c.rt.texture;c.blur.uniforms.dir.value.set(amount/512,0);R.setRenderTarget(c.rb);R.render(c.qscene,c.qcam);
    c.blur.uniforms.tDiffuse.value=c.rb.texture;c.blur.uniforms.dir.value.set(0,amount/512);R.setRenderTarget(c.rt);R.render(c.qscene,c.qcam);
  }
  R.setRenderTarget(null);R.setClearColor(0x000000,clear);hidden.forEach(o=>{o.visible=o.userData.wasVisible;});
}

function addSpark(parent,x,y,z,size,speed,phase){
const m=new T.SpriteMaterial({map:starTex,blending:T.AdditiveBlending,transparent:true,depthWrite:false,color:0xffffff,opacity:1});
const s=new T.Sprite(m);
s.position.set(x,y,z);
s.scale.setScalar(.01);
parent.add(s);
sparks.push({s,size,speed,phase:phase??Math.random()*TAU});
}

function diamonds(list,mat){
const im=new T.InstancedMesh(diaGeo,mat,list.length);
const m=new T.Matrix4();
list.forEach((d,i)=>{m.compose(d.p,d.q,new T.Vector3(d.s,d.s,d.s));im.setMatrixAt(i,m);});
im.instanceMatrix.needsUpdate=true;
return im;
}

function clearGroup(){
const mats=new Set();
group.traverse(o=>{if(o.isInstancedMesh)o.dispose();if(o.material){(Array.isArray(o.material)?o.material:[o.material]).forEach(m=>mats.add(m));}});
for(const o of owned)o.dispose();
for(const m of mats)m.dispose();
owned=[];sparks=[];
while(group.children.length)group.remove(group.children[0]);
}
const own=g=>{owned.push(g);return g;};
const UP=T?new T.Vector3(0,1,0):null;

function build(S){
  dirty=true;clearGroup();
  const J=JONCS[S.jonc],sh=S.forme,{W,L,D}=dims(sh,S.carats);
  const ri=S.taille/TAU,ro=ri+J.t,ch=D*.28,ph=D*.72;
  const gy=ro+ph+.40+(S.hauteur==='haute'?HAUTEURS.haute.dy:0);
  const profil=PROFILS[S.profil]?S.profil:'bombe',split=profil==='divise'?.62:0;
  const alloy=GOLD3D[S.metal]||GOLD3D.jaune;
  const gold=new T.MeshPhysicalMaterial({color:alloy.color,metalness:1,roughness:alloy.roughness,envMapIntensity:alloy.envMapIntensity,side:T.DoubleSide});
  const goldSatin=gold.clone();goldSatin.roughness=alloy.satin;
  const mesh=(geo,mat=gold,parent=group)=>{const m=new T.Mesh(own(geo),mat);parent.add(m);return m;};
  const wire=(pts,r0,r1,mat=gold,parent=group)=>mesh(taperedWire(pts,r0,r1),mat,parent);
  const beadGeo=own(new T.SphereGeometry(1,12,8));
  const beads=[];
  const bead=(p,r)=>beads.push({p:new T.Vector3(...p),q:new T.Quaternion(),s:r});
  mesh(bandGeo(ri,ro,J.w,profil,split));
  const rc=ri+J.t*.5;
  const mainGeometry=own(stoneGeo(sh,W,L,D));
  stoneMat=GemOptics.material(mainGeometry,envCube,S.teinte,W);
  const stone=GemOptics.attach(new T.Mesh(mainGeometry,stoneMat));stone.position.y=gy;group.add(stone);
  let haloCount=0,paveCount=0,sideCount=0;

  // Four fine structural arms attached to the upper shank, not a solid central stem.
  const armOutline=sh==='poire'?outline(sh,W,L):null;
  for(const sg of[-1,1])for(const zz of[-1,1]){
    const ax=Math.min(W*.34,ro*.66)*sg,ay=Math.sqrt(Math.max(1,ro*ro-ax*ax));
    let ex=W*.40*sg,ez=L*.29*zz;
    if(armOutline){const e=extreme(armOutline,sg*.8,zz*.6);ex=e[0]*.86;ez=e[1]*.86;}
    wire([[ax,ay-.32,zz*J.w*.28],[ax*1.03,ro+.35,zz*J.w*.44],[ex,gy-D*.30,ez],[ex,gy-.45,ez]],.23,.17);
    if(split){
      // Split shank: each shoulder divides into two strands that rejoin under the head.
      // Strands stay on the band circle and climb monotonically to the arm roots (no overshoot loop).
      const at=(phi,r)=>[sg*r*Math.sin(phi),r*Math.cos(phi)];
      const pa=Math.asin(Math.min(.95,Math.abs(ax)/(ro-.32))),lerp=t=>split+.05+(pa-split-.05)*t;
      const p0=at(lerp(0),rc),p1=at(lerp(.35),rc+.05),p2=at(lerp(.72),rc+.02);
      const rs=Math.min(J.w*.3,J.t*.42);
      wire([[p0[0],p0[1],zz*J.w*.16],[p1[0],p1[1],zz*(J.w*.5+.32)],[p2[0],p2[1],zz*(J.w*.5+.18)],[ax,ay-.32,zz*J.w*.28]],rs,rs*.85);
    }
  }

  const base=outline(sh,W,L);
  if(S.monture!=='clos'){
    mesh(contourTube(outline(sh,W*.93,L*.93),gy-.38,.155));
    // Lower open gallery; keeps the pavilion visible from the side.
    mesh(contourTube(outline(sh,W*.48,L*.48),gy-D*.53,.13));
    const gr=griffesOf(S),rp=T.MathUtils.clamp(.24+.014*W,.3,.4);
    // The pear is held by five prongs: a V on the tip, two at the widest point, two around the rounded end.
    const pearV=sh==='poire'&&(gr==='classiques'||gr==='v');
    let dirs=sh==='poire'?(pearV?[[-1,.08],[1,.08],[-.62,-1],[.62,-1]]:[[0,1],[-1,-.62],[1,-.62]]):[[1,1],[-1,1],[1,-1],[-1,-1]];
    if(gr==='six')dirs=sh==='poire'?[[0,1],[-1,-.62],[1,-.62],[-1,.42],[1,.42],[0,-1]]:sh==='emeraude'||sh==='baguette'?[[1,1],[-1,1],[1,-1],[-1,-1],[1,0],[-1,0]]:Array.from({length:6},(_,i)=>[Math.cos(i*Math.PI/3+Math.PI/6),Math.sin(i*Math.PI/3+Math.PI/6)]);
    const spots=[];
    for(const d of dirs){
      if(gr==='doubles'){for(const da of[-.2,.2]){const c=Math.cos(da),s=Math.sin(da);spots.push(extreme(base,d[0]*c-d[1]*s,d[0]*s+d[1]*c));}}
      else spots.push(extreme(base,d[0],d[1]));
    }
    for(const e of spots){
      const x=e[0],z=e[1],r=gr==='doubles'?rp*.82:rp,h=Math.hypot(x,z)||1,nx=x/h*r*.8,nz=z/h*r*.8;
      const pts=[[x*.49,gy-D*.52,z*.49],[x*.83+nx*.5,gy-D*.28,z*.83+nz*.5],[x+nx,gy-.12,z+nz],[x+nx,gy+D*.052,z+nz],[x*.95+nx*.4,gy+D*.13,z*.95+nz*.4]];
      wire(pts,r,r*.72);bead(pts[4],r*.74);
    }
    if(gr==='v'||pearV){
      // V prongs: a gold chevron wraps each fragile corner (pear tip, emerald-cut corners).
      const corners=sh==='poire'?[[0,1]]:[[1,1],[-1,1],[1,-1],[-1,-1]];
      for(const d of corners){
        const e=extreme(base,d[0],d[1]),n=Math.hypot(d[0],d[1]),dx=d[0]/n,dz=d[1]/n,tx=-dz,tz=dx,y=gy+D*.035,arm=sh==='poire'?.72:.7;
        const tip=[e[0]+dx*rp*.9,y,e[1]+dz*rp*.9];
        for(const s of[-1,1])wire([[e[0]+tx*s*arm-dx*arm*.9,y+D*.02,e[1]+tz*s*arm-dz*arm*.9],tip],rp*.72,rp*.86);
        wire([[e[0]*.49,gy-D*.52,e[1]*.49],[e[0]*.86+dx*rp*.5,gy-D*.28,e[1]*.86+dz*rp*.5],[e[0]+dx*rp,gy-.12,e[1]+dz*rp],tip],rp,rp*.86);
        bead(tip,rp*.9);
      }
    }
  }

  if(S.monture==='clos'){
    mesh(bezelGeo(sh,W,L,gy,D),goldSatin);
    mesh(contourTube(outline(sh,W+.27,L+.27),gy+.053,.125));
    mesh(contourTube(outline(sh,(W+.52)*.72,(L+.52)*.72),gy-D*.46,.12));
  }

  const addMelee=list=>{
    if(!list.length)return;
    const material=GemOptics.material(diaGeo,envCube,'vif',1,true,{melee:true});
    const gems=GemOptics.attach(diamonds(list,material));group.add(gems);
  };

  if(S.monture==='halo'){
    const dd=T.MathUtils.clamp(W*.143,.85,1.18);
    const hp=along(outline(sh,W+dd*.97,L+dd*.97),dd*1.055);
    const hy=gy-.005;
    // Diamonds sit on a fine open rail: no flat gold plate surrounding the center stone.
    mesh(contourTube(hp,hy-dd*.23,.14));
    const list=hp.map(q=>({p:new T.Vector3(q[0],hy,q[1]),q:new T.Quaternion(),s:dd}));
    for(let i=0;i<hp.length;i++){
      const a=hp[i],b=hp[(i+1)%hp.length],mx=(a[0]+b[0])/2,mz=(a[1]+b[1])/2,n=Math.hypot(mx,mz),nx=mx/n,nz=mz/n;
      for(const sg of[-1,1])bead([mx+nx*dd*.22,hy+dd*.035,mz+nz*dd*.22],dd*.092);
    }
    if(S.haloRang==='double'){
      const d2=dd*.86,off=dd*.97+d2*1.02;
      const hp2=along(outline(sh,W+off*2-dd*.97,L+off*2-dd*.97),d2*1.055);
      const hy2=hy-d2*.18;
      mesh(contourTube(hp2,hy2-d2*.23,.13));
      for(const q of hp2)list.push({p:new T.Vector3(q[0],hy2,q[1]),q:new T.Quaternion(),s:d2});
      for(let i=0;i<hp2.length;i++){
        const a=hp2[i],b=hp2[(i+1)%hp2.length],mx=(a[0]+b[0])/2,mz=(a[1]+b[1])/2,n=Math.hypot(mx,mz),nx=mx/n,nz=mz/n;
        bead([mx+nx*d2*.22,hy2+d2*.035,mz+nz*d2*.22],d2*.09);
      }
    }
    addMelee(list);haloCount=list.length;
  }

  let hiddenCount=0;
  if(S.cache&&S.monture!=='clos'){
    const dh=T.MathUtils.clamp(W*.085,.55,.82);
    const yh=gy-D*.36;
    const hh=along(outline(sh,W*.74,L*.74),dh*1.06);
    mesh(contourTube(hh,yh-dh*.24,.12));
    addMelee(hh.map(q=>({p:new T.Vector3(q[0],yh,q[1]),q:new T.Quaternion(),s:dh})));hiddenCount=hh.length;
  }

  let sideReach=0;
  if(S.monture==='trois'){
    const k=(LAT_TAILLES[S.latTaille]||LAT_TAILLES.moyenne).k,lf=LAT_FORMES[S.latForme]?S.latForme:'rond';
    const ds=T.MathUtils.clamp(W*.46,2.25,3.75)*k,em=S.lat==='emeraude';
    // [extent across the band, extent along the band]; pears and trapezoids taper away from the centre stone.
    const ext={rond:[ds,ds],poire:[ds*.78,ds*1.2],baguette:[ds*.52,ds*1.12],trapeze:[ds*1.02,ds*.86]}[lf];
    const half=ext[1]/2,dmin=Math.min(ext[0],ext[1]);
    sideReach=W/2+half*1.86+.48;
    for(const sg of[-1,1]){
      const g=new T.Group();g.position.set(sg*(W/2+half*.86+.18),gy-dmin*.32-.35,0);g.rotation.z=-sg*.18;group.add(g);
      const gi=new T.Group();gi.rotation.y=lf==='poire'?sg*Math.PI/2:lf==='rond'?0:sg*Math.PI/2;g.add(gi);
      let sideGeo;
      if(lf==='rond'){sideGeo=own(em?stoneGeo('rond',ds,ds,ds*.62):makeDiamond());if(!em)sideGeo.scale(ds,ds,ds);}
      else sideGeo=own(stoneGeo(lf,ext[0],ext[1],dmin*.66));
      const sm=GemOptics.attach(new T.Mesh(sideGeo,GemOptics.material(sideGeo,envCube,S.teinte,dmin,!em)));gi.add(sm);sideCount++;
      const so=outline(lf,ext[0],ext[1]);
      mesh(contourTube(so.map(q=>[q[0]*.94,q[1]*.94]),-.22,.135),gold,gi);
      const sdirs=lf==='poire'?[[0,1],[-1,-.62],[1,-.62]]:[[1,1],[-1,1],[1,-1],[-1,-1]];
      for(const d of sdirs){
        const e=extreme(so,d[0],d[1]),x=e[0]*1.02,z=e[1]*1.02;
        wire([[x*.25,-dmin*.54,z*.25],[x*.83,-dmin*.25,z*.83],[x,.04,z],[x*.91,.15,z*.91]],.135,.10,gold,gi);
        const tip=mesh(new T.SphereGeometry(.10,10,8),gold,gi);tip.position.set(x*.91,.15,z*.91);
      }
      const x=g.position.x;
      const bandX=sg*Math.min(ro*.75,Math.abs(x)),bandY=Math.sqrt(Math.max(1,ro*ro-bandX*bandX));
      wire([[bandX,bandY-.2,0],[x*.95,ro+.55,0],[x,g.position.y-dmin*.32,0]],J.w*.20,.20);
    }
  }

  if(S.pave){
    const dd=Math.min(J.w*.53,1.30);
    const edge=W/2+(S.monture==='trois'?sideReach-W/2:S.monture==='halo'?(S.haloRang==='double'?2.45:1.40):S.monture==='clos'?.7:.50);
    const th0=Math.max(split?split+.08:0,Math.asin(Math.min(.95,edge/ro)));
    const list=[];
    const thMax=S.paveEtendue==='epaules'?Math.min(1.39,th0+.62):S.paveEtendue==='complet'?Math.PI-dd*.56/ro:1.39;
    for(const sg of[-1,1])for(let th=th0;th<thMax;th+=dd*1.08/ro){
      const dir=new T.Vector3(sg*Math.sin(th),Math.cos(th),0),q=new T.Quaternion().setFromUnitVectors(UP,dir);
      const center=dir.clone().multiplyScalar(ro+dd*.075);list.push({p:center,q,s:dd});
      for(const side of[-1,1]){
        const p=center.clone().add(new T.Vector3(0,0,side*dd*.46)).addScaledVector(dir,dd*.04);bead([p.x,p.y,p.z],dd*.095);
      }
    }
    addMelee(list);paveCount=list.length;
  }
  let allianceCount=0;
  if(S.alliance==='lisse'||S.alliance==='pavee'){
    // Matching wedding band beside the engagement ring, same width and section.
    const za=-(J.w+.22),band=mesh(bandGeo(ri,ro,J.w,profil==='plat'?'plat':'bombe'));band.position.z=za;
    if(S.alliance==='pavee'){
      const dd=Math.min(J.w*.53,1.30),list=[];
      for(let th=-1.25;th<=1.25;th+=dd*1.08/ro){
        const dir=new T.Vector3(Math.sin(th),Math.cos(th),0),q=new T.Quaternion().setFromUnitVectors(UP,dir);
        const p=dir.clone().multiplyScalar(ro+dd*.075);p.z=za;list.push({p,q,s:dd});
        for(const side of[-1,1]){const b=p.clone().add(new T.Vector3(0,0,side*dd*.46)).addScaledVector(dir,dd*.04);bead([b.x,b.y,b.z],dd*.095);}
      }
      addMelee(list);allianceCount=list.length;
    }
  }
  if(beads.length){
    const instance=new T.InstancedMesh(beadGeo,gold,beads.length),matrix=new T.Matrix4();
    beads.forEach((d,i)=>{matrix.compose(d.p,d.q,new T.Vector3(d.s,d.s,d.s));instance.setMatrixAt(i,matrix);});instance.instanceMatrix.needsUpdate=true;group.add(instance);
  }
  burst=null;
  const top=gy+ch+.4,bottom=-ro-.3;
  fit.cy=(top+bottom)/2+(top-bottom)*.035;fit.hh=(top-bottom)/2*.91;
  fit.ww=Math.max(ro+.4,S.monture==='trois'?sideReach+.3:W/2+(S.monture==='halo'&&S.haloRang==='double'?2.6:1.5));
  fit.stoneY=gy+ch*.2;fit.stoneSize=Math.max(W,L)*.7;
  shadow.position.y=-ro-.35;shadow.scale.set(ro*2.4,ro*1.55,1);
  contact.y=-ro-.02;contact.size=Math.max(ro*2,sideReach*2,L+2)*1.45;contact.top=contact.y+ro*.85;contact.dirty=true;
  geometryStats={version:'3.2.0',shape:sh,mount:S.monture,prongs:S.monture==='clos'?'clos':griffesOf(S),profile:profil,setHeight:S.hauteur==='haute'?'haute':'basse',sideShape:S.monture==='trois'?(LAT_FORMES[S.latForme]?S.latForme:'rond'):null,haloDiamonds:haloCount,hiddenHaloDiamonds:hiddenCount,paveDiamonds:paveCount,weddingBand:S.alliance==='lisse'||S.alliance==='pavee'?S.alliance:null,weddingBandDiamonds:allianceCount,sideStones:sideCount,centralFacetPlanes:stoneMat.userData.planeCount,drawObjects:group.children.length,estimatedDimensions:{W,L,D},manufacturingValidated:false};
  applyView(lastS!==null);popAt=-1;flashAt=-1;lastS=S;
}

function distFor(mult){
const t=Math.tan(cam.fov*Math.PI/360);
const dv=fit.hh*1.15/t,dh=fit.ww*1.19/(t*cam.aspect);
return Math.max(dv,dh)*mult*userZoom*1.12;
}

function applyView(animate){
const m={
angle:{yaw:null,pitch:.68,mult:1,ty:fit.cy},
face:{yaw:0,pitch:.12,mult:1,ty:fit.cy},
profil:{yaw:Math.PI/2,pitch:.16,mult:1,ty:fit.cy},
dessus:{yaw:0,pitch:1.48,mult:.97,ty:fit.cy},
pierre:{yaw:.26,pitch:1.20,mult:.44,ty:fit.stoneY??fit.cy},
libre:{yaw:null,pitch:V.tpitch,mult:1,ty:fit.cy}
}[mode];
if(m.yaw!==null){
let d=m.yaw-(V.tyaw%TAU);
d=((d+Math.PI)%TAU+TAU)%TAU-Math.PI;
V.tyaw=V.tyaw+d;
}
V.tpitch=m.pitch;V.tdist=distFor(m.mult);V.tty=m.ty;
if(!animate){V.pitch=V.tpitch;V.dist=V.tdist;V.ty=V.tty;}
}

function setView(name){
if(!['angle','face','profil','dessus','pierre'].includes(name))return;
mode=name;
userZoom=1;
if(name==='angle'){V.tyaw=.38;presentationPhase=0;}
auto=name==='angle'&&!paused&&!reduce;
lastInput=clock0;
applyView(true);
if(viewCb)viewCb(name);
}

function resize(){
if(!R)return;
dirty=true;
const r=host.getBoundingClientRect();
const w=Math.max(2,Math.round(r.width)),h=Math.max(2,Math.round(r.height));
R.setPixelRatio(Math.min(window.devicePixelRatio||1,w<600?1.65:1.8));
R.setSize(w,h,false);
cam.aspect=w/h;cam.updateProjectionMatrix();
applyView(false);
}

function renderFrame(now){
const t=now/1000;clock0=t;
const moving=Math.abs(V.yaw-V.tyaw)+Math.abs(V.pitch-V.tpitch)+Math.abs(V.dist-V.tdist)+Math.abs(V.ty-V.tty)>.0005;
if(!dirty&&(paused||reduce)&&!moving&&popAt>=0&&(reduce||t-popAt>.8))return;
dirty=false;
const dt=Math.min(.05,prevT?t-prevT:.016);prevT=t;
if(popAt<0)popAt=t;
if(auto&&!paused&&!reduce){presentationPhase+=dt*.20;V.tyaw=.38+Math.sin(presentationPhase)*.27;}
const k=reduce?1:1-Math.exp(-dt*7.0);
V.yaw+=(V.tyaw-V.yaw)*k;V.pitch+=(V.tpitch-V.pitch)*k;V.dist+=(V.tdist-V.dist)*k;V.ty+=(V.tty-V.ty)*k;
const cp=Math.cos(V.pitch);
cam.position.set(Math.sin(V.yaw)*cp*V.dist,V.ty+Math.sin(V.pitch)*V.dist,Math.cos(V.yaw)*cp*V.dist);
cam.lookAt(0,V.ty,0);
const p=reduce?1:Math.min(1,(t-popAt)/.7);
group.scale.setScalar(.985+.015*easeOutCubic(p));
group.rotation.z=-.12;
group.rotation.y=0;
group.position.y=reduce||paused?0:Math.sin(t*.6)*.07;
shadow.material.opacity=dark?.16:.1;
if(contact.dirty)renderContact();
if(burst)burst.material.opacity=0;
for(const s of sparks){
const v=reduce||paused?0:Math.pow(Math.max(0,Math.sin(t*s.speed*.45+s.phase)),36);
s.s.scale.setScalar(Math.max(.001,s.size*.28*v));
s.s.material.opacity=v*.28;
}
R.render(scene,cam);
}
function frame(now){
raf=0;
if(!visible||document.hidden||!intersecting)return;
renderFrame(now);
raf=requestAnimationFrame(frame);
}
function wake(){
visible=!document.hidden;
if(visible&&intersecting&&!raf){prevT=0;raf=requestAnimationFrame(frame);}
}

function bindInput(el){
// Mouse and touch rotate in every direction; two fingers pinch to zoom. The page scrolls from the options panel.
const pts=new Map();let lx=0,ly=0,pinch=0;
el.style.touchAction='none';
const center=()=>{let x=0,y=0;for(const p of pts.values()){x+=p.x;y+=p.y;}return[x/pts.size,y/pts.size];};
const spread=()=>{const a=[...pts.values()];return a.length<2?0:Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y);};
el.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button!==0)return;pts.set(e.pointerId,{x:e.clientX,y:e.clientY});[lx,ly]=center();pinch=spread();auto=false;try{el.setPointerCapture(e.pointerId);}catch(_){}});
el.addEventListener('pointermove',e=>{
if(!pts.has(e.pointerId))return;
pts.set(e.pointerId,{x:e.clientX,y:e.clientY});
const[cx,cy]=center(),dx=cx-lx,dy=cy-ly;lx=cx;ly=cy;
if(pts.size>=2){const d=spread();if(pinch>0&&d>0){userZoom=T.MathUtils.clamp(userZoom*pinch/d,.6,1.5);applyView(true);}pinch=d;return;}
const k=e.pointerType==='touch'?.012:.009;
V.tyaw-=dx*k;
V.tpitch=Math.max(-1.25,Math.min(1.50,V.tpitch+dy*(e.pointerType==='touch'?.008:.006)));
dirty=true;
if(mode!=='libre'){mode='libre';if(viewCb)viewCb('libre');}
});
const up=e=>{pts.delete(e.pointerId);if(pts.size){[lx,ly]=center();pinch=spread();}};
el.addEventListener('pointerup',up);el.addEventListener('pointercancel',up);el.addEventListener('lostpointercapture',up);
el.addEventListener('keydown',e=>{
if(['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','+','-',' '].includes(e.key))e.preventDefault();
if(e.key==='ArrowLeft'){V.tyaw+=.18;auto=false;}
if(e.key==='ArrowRight'){V.tyaw-=.18;auto=false;}
if(e.key==='ArrowUp'){V.tpitch=Math.min(1.5,V.tpitch+.12);auto=false;}
if(e.key==="ArrowDown"){V.tpitch=Math.max(-1.25,V.tpitch-.12);auto=false;}
if(e.key==='Home')setView('angle');
if(e.key==='+')zoom(.9);if(e.key==='-')zoom(1.1);
if(e.key===' '){setAuto(paused);host.dispatchEvent(new CustomEvent('ring3d-pause',{detail:paused}));}
});
}

function init(container){
if(!T||typeof GemOptics==='undefined')return false;
host=container;
motionQuery=window.matchMedia('(prefers-reduced-motion: reduce)');reduce=motionQuery.matches;
paused=reduce;auto=!reduce;
try{
const cv=document.createElement('canvas');
cv.setAttribute('role','img');
cv.setAttribute('aria-label',(typeof JA_T==='function'?JA_T:function(t){return t;})('Apercu 3D. Faites glisser pour tourner. Fleches pour orienter. Plus et moins pour zoomer.'));
cv.tabIndex=0;
R=new T.WebGLRenderer({canvas:cv,antialias:true,alpha:true,powerPreference:'high-performance',preserveDrawingBuffer:true});
R.outputColorSpace=T.SRGBColorSpace;
R.toneMapping=T.ACESFilmicToneMapping;
R.toneMappingExposure=1.03;
R.setClearColor(0x000000,0);
scene=new T.Scene();
cam=new T.PerspectiveCamera(30,1,.1,500);
host.appendChild(cv);
scene.environment=makeEnv();
starTex=starTexture();glowTex=glowTexture();diaGeo=makeDiamond();
group=new T.Group();scene.add(group);
shadow=new T.Mesh(new T.PlaneGeometry(1,1),new T.MeshBasicMaterial({map:glowTex,transparent:true,depthWrite:false,opacity:.33,color:'#504528'}));
shadow.rotation.x=-Math.PI/2;scene.add(shadow);makeContact();
bindInput(cv);
cv.addEventListener('webglcontextlost',e=>{e.preventDefault();visible=false;cancelAnimationFrame(raf);raf=0;host.dispatchEvent(new Event('ring3d-lost'));});
resizeObserver=new ResizeObserver(resize);resizeObserver.observe(host);
if('IntersectionObserver' in window){intersection=new IntersectionObserver(en=>{intersecting=en[0].isIntersecting;wake();});intersection.observe(host);}
document.addEventListener('visibilitychange',wake);
motionQuery.addEventListener('change',e=>{reduce=e.matches;paused=reduce;auto=!reduce;dirty=true;host.dispatchEvent(new CustomEvent('ring3d-pause',{detail:paused}));});
resize();wake();
(window.requestIdleCallback||setTimeout)(loadStudio);
return true;
}catch(err){console.warn('Ring viewer fallback:',err);if(R)R.dispose();return false;}
}
function update(S){
if(!R)return;
const key=JSON.stringify([S.forme,S.carats,S.teinte,S.monture,S.lat,S.metal,S.jonc,S.pave,S.taille,S.haloRang,S.paveEtendue,S.cache,S.griffes,S.latForme,S.latTaille,S.profil,S.hauteur,S.alliance]);
if(lastS&&lastS._visualKey===key)return;
build({...S,_visualKey:key});
}
function setFinger(){}
function zoom(factor){if(!R)return;userZoom=T.MathUtils.clamp(userZoom*factor,.6,1.5);applyView(true);}
function setAuto(on){dirty=true;const enabled=Boolean(on)&&!reduce;paused=!enabled;auto=enabled;if(enabled&&mode!=='angle')setView('angle');}
function setTheme(value){dirty=true;dark=value==='dark';if(shadow)shadow.material.color.set(dark?'#030b06':'#665538');if(contact.mesh)contact.mesh.material.color.set(dark?'#000000':'#3a2c14');}
function capture(){if(!R)return null;dirty=true;renderFrame(performance.now());return R.domElement.toDataURL('image/png');}
function thumbnail(S,view='angle'){
if(!R)return null;
const saved={s:lastS,mode,v:{...V},auto,paused,zoom:userZoom};
paused=true;auto=false;userZoom=1;mode=view;build(S);V.tyaw=.38;applyView(false);V.yaw=V.tyaw;
group.scale.setScalar(1);popAt=-100;
renderFrame(performance.now());
const data=R.domElement.toDataURL('image/png');
mode=saved.mode;paused=saved.paused;auto=saved.auto;userZoom=saved.zoom;build(saved.s);Object.assign(V,saved.v);popAt=-100;
return data;
}
function dispose(){cancelAnimationFrame(raf);resizeObserver?.disconnect();intersection?.disconnect();document.removeEventListener('visibilitychange',wake);if(group)clearGroup();diaGeo?.dispose();starTex?.dispose();glowTex?.dispose();envTarget?.dispose();envPMREM?.dispose();contact.rt?.dispose();contact.rb?.dispose();contact.mesh?.geometry.dispose();contact.mesh?.material.dispose();contact.quad?.geometry.dispose();contact.blur?.dispose();contact.depth?.dispose();shadow?.geometry.dispose();shadow?.material.dispose();R?.dispose();}
return{init,update,setView,setFinger,get finger(){return false;},zoom,setAuto,setTheme,capture,thumbnail,dispose,onView:f=>{viewCb=f;},get mode(){return mode;},get paused(){return paused;},get renderer(){return R;},get studio(){return studioReady;},get diagnostics(){return geometryStats?JSON.parse(JSON.stringify(geometryStats)):null;}};
})();

;
/* app.js */
'use strict';
const $ = selector => document.querySelector(selector);
const form = $('#cfg');
const radios = name => form.querySelector(`input[name="${name}"]:checked`)?.value || '';
const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const HOST_CONFIG = window.JOHYA_ATELIER_CONFIG || {};
const tr = typeof JA_T === 'function' ? JA_T : (text => text);
const LOC = typeof JA_LOC === 'string' ? JA_LOC : 'fr';
const fmt = (n, d = 2) => LOC === 'en' ? n.toFixed(d) : fm(n, d);
const API_BASE = HOST_CONFIG.api === false ? null : (HOST_CONFIG.api || './api/');
const MOUNT_ASSETS = HOST_CONFIG.mounts || {solitaire:'assets/monture-solitaire.webp',halo:'assets/monture-halo.webp',trois:'assets/monture-trois.webp',clos:'assets/monture-clos.webp'};
const DEFAULTS = {forme:'emeraude',carats:2,teinte:'vivid',ref:'',monture:'solitaire',lat:'diamant',metal:'jaune',jonc:'fin',pave:false,origine:'nat',taille:54,tailleInc:false,gravure:'',haloRang:'simple',paveEtendue:'demi',cache:false,griffes:'classiques',latForme:'rond',latTaille:'moyenne',profil:'bombe',hauteur:'basse',alliance:'aucune',police:'classique'};
let lastDescription, lastConfig, use3d=false, pending=0, toastTimer, openIndex=1, aiAvailable=false, generating=false;
let lastAIConfig=null, lastAIImage=null, lastAICode=null;

for(let size=44;size<=70;size++){
  const option=document.createElement('option');option.value=size;option.textContent=`${size} (${tr('tour int\u00e9rieur')} ${size} mm)`;option.selected=size===54;$('#taille').append(option);
}
function read(){
  return {forme:radios('forme'),carats:Number($('#carats').value),teinte:radios('teinte'),ref:$('#ref').value.trim(),monture:radios('monture'),lat:radios('lat'),metal:radios('metal'),jonc:radios('jonc'),pave:$('#pave').checked,origine:radios('origine'),taille:Number($('#taille').value),tailleInc:$('#tailleInc').checked,gravure:$('#gravure').value.trim(),haloRang:radios('haloRang')||'simple',paveEtendue:radios('paveEtendue')||'demi',cache:$('#cache').checked,griffes:radios('griffes')||'classiques',latForme:radios('latForme')||'rond',latTaille:radios('latTaille')||'moyenne',profil:radios('profil')||'bombe',hauteur:radios('hauteur')||'basse',alliance:radios('alliance')||'aucune',police:radios('police')||'classique'};
}
function apply(config){
  const enums={forme:Object.keys(SHAPES),teinte:Object.keys(TINTS),monture:Object.keys(MONT),lat:['diamant','emeraude'],metal:Object.keys(METALS),jonc:Object.keys(JONCS),origine:['nat','syn'],haloRang:Object.keys(HALO_RANGS),paveEtendue:Object.keys(PAVE_ETENDUES),griffes:Object.keys(GRIFFES),latForme:Object.keys(LAT_FORMES),latTaille:Object.keys(LAT_TAILLES),profil:Object.keys(PROFILS),hauteur:Object.keys(HAUTEURS),alliance:Object.keys(ALLIANCES),police:Object.keys(POLICES)};
  config={...config,teinte:TINT_ALIASES[config.teinte]||config.teinte};
  for(const [key,values] of Object.entries(enums)){
    const value=values.includes(config[key])?config[key]:DEFAULTS[key];
    form.querySelector(`input[name="${key}"][value="${value}"]`).checked=true;
  }
  $('#carats').value=Math.round(Math.min(5,Math.max(.5,Number(config.carats)||2))*20)/20;
  $('#taille').value=Math.round(Math.min(70,Math.max(44,Number(config.taille)||54)));
  $('#pave').checked=config.pave===true;$('#cache').checked=config.cache===true;$('#tailleInc').checked=config.tailleInc===true;
  $('#ref').value=String(config.ref||'').slice(0,20);$('#gravure').value=String(config.gravure||'').slice(0,24);
}
function scopedSVG(svg,prefix){return svg.replace(/id="([^"]+)"/g,(_,id)=>`id="${prefix}-${id}"`).replace(/url\(#([^)]+)\)/g,(_,id)=>`url(#${prefix}-${id})`);}
function render(){
  const S=read();lastConfig=S;
  const {W,L,D}=dims(S.forme,S.carats);
  $('#carOut').innerHTML=`${fmt(S.carats)} <small>ct</small>`;
  {const range=$('#carats'),lo=Number(range.min)||.5,hi=Number(range.max)||5;range.style.setProperty('--pct',`${(S.carats-lo)/(hi-lo)*100}%`);}
  $('#carats').setAttribute('aria-valuetext',`${fmt(S.carats)} ${tr('carats')}`);
  $('#dimOut').textContent=`${tr('Dimensions estim\u00e9es :')} ${fmt(L,1)} \u00d7 ${fmt(W,1)} mm`;
  $('#stageDims').textContent=`${tr('Pierre')} \u2248 ${fmt(L,1)} \u00d7 ${fmt(W,1)} mm \u00b7 ${tr('Proportions indicatives')}`;
  const title=$('#stageTitle');title.replaceChildren(document.createTextNode(MONT[S.monture].n+' '));
  const sep=document.createElement('span');sep.textContent='\u00b7';title.append(sep,document.createTextNode(' '+METALS[S.metal].n));
  $('#heroShape').firstChild.textContent=SHAPES[S.forme].t.charAt(0).toUpperCase()+SHAPES[S.forme].t.slice(1);
  $('#heroCarat').textContent=`${fmt(S.carats)} ${tr('carats')}`;
  $('#lat').hidden=$('#latForme').hidden=$('#latTaille').hidden=S.monture!=='trois';
  const vOk=GRIFFES_V.includes(S.forme);$('#griffeV').hidden=!vOk;
  if(!vOk&&S.griffes==='v'){form.querySelector('input[name="griffes"][value="classiques"]').checked=true;S.griffes='classiques';}
  $('#griffesField').hidden=S.monture==='clos';
  $('#griffesNote').textContent=tr({classiques:S.forme==='poire'?'Trois griffes, dont une à la pointe.':'Quatre griffes, la pierre très visible.',six:'Six griffes : une tenue renforcée, un dessin plus rond.',doubles:'Chaque griffe est dédoublée : finesse et sécurité.',v:S.forme==='poire'?'Une griffe en V protège la pointe de la poire.':'Des griffes en V protègent les quatre angles.'}[S.griffes]);
  $('#haloRang').hidden=S.monture!=='halo';
  $('#paveEtendue').hidden=!S.pave;
  $('#cacheRow').hidden=S.monture==='clos';
  $('#origine').hidden=!(S.monture==='halo'||S.pave||(S.cache&&S.monture!=='clos')||(S.monture==='trois'&&S.lat==='diamant'));
  $('#hint').hidden=!((S.forme==='emeraude'||S.forme==='baguette')&&S.monture!=='clos');
  $('#taille').disabled=S.tailleInc;
  $('#sum1').textContent=`${SHAPES[S.forme].n} \u00b7 ${fmt(S.carats)} ct \u00b7 ${TINTS[S.teinte].n}`;
  $('#tintName').textContent=TINTS[S.teinte].n;
  const cap=t=>t.charAt(0).toUpperCase()+t.slice(1);
  $('#sum2').textContent=[MONT[S.monture].n,S.monture!=='clos'&&S.griffes!=='classiques'?cap(GRIFFES[griffesOf(S)].n):'',S.hauteur==='haute'?tr('Sertissage haut'):''].filter(Boolean).join(' \u00b7 ');
  $('#sum3').textContent=[METALS[S.metal].n,S.profil!=='bombe'?tr({plat:'Jonc plat',divise:'Jonc divis\u00e9'}[S.profil]||''):'',S.monture==='halo'&&S.haloRang==='double'?tr('Double halo'):'',S.pave?tr('Pav\u00e9 de diamants'):'',S.cache&&S.monture!=='clos'?tr('Halo cach\u00e9'):'',S.alliance!=='aucune'?tr({lisse:'Alliance lisse',pavee:'Alliance pav\u00e9e'}[S.alliance]||''):''].filter(Boolean).join(' \u00b7 ');
  $('#sum4').textContent=(S.tailleInc?tr('Taille \u00e0 d\u00e9terminer'):`${tr('Taille')} ${S.taille}`)+(S.gravure?' \u00b7 '+tr('Gravure personnelle'):'');
  $('#engravingPreview').dataset.font=S.police;
  $('#charCount').textContent=`${$('#gravure').value.length} / 24`;
  $('#engravingText').textContent=S.gravure;$('#engravingPreview').hidden=!S.gravure;
  const d=describe(S);lastDescription=d;
  const fragment=document.createDocumentFragment();
  for(const [key,value] of d.rows){const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=key;dd.textContent=value;fragment.append(dt,dd);}
  $('#recapRows').replaceChildren(fragment);$('#code').textContent=d.code;$('#sum5').textContent=tr('Une pi\u00e8ce \u00e0 imaginer ensemble');
  $('#wa').href='https://wa.me/33619306911?text='+encodeURIComponent(d.text+'\n'+tr('Lien :')+' '+shareURL(S)+'\n\n'+tr('Aper\u00e7u indicatif, projet \u00e0 valider avec l\u2019atelier.'));
  if(use3d){cancelAnimationFrame(pending);pending=requestAnimationFrame(()=>{try{Ring3D.update(S);}catch(error){console.warn('Viewer unavailable',error);fallback();}});}
  else {$('#vTop').innerHTML=scopedSVG(topView(S),'fallback-top');$('#vFace').innerHTML=scopedSVG(faceView(S),'fallback-face');}
  if(lastAIConfig&&JSON.stringify(visualConfig(S))!==lastAIConfig)$('#aiStatus').textContent='Ce rendu correspond \u00e0 votre configuration pr\u00e9c\u00e9dente. G\u00e9n\u00e9rez un nouveau rendu pour refl\u00e9ter vos modifications.';
}
function toast(message){$('#toast').textContent=message;$('#toast').classList.add('on');clearTimeout(toastTimer);toastTimer=setTimeout(()=>$('#toast').classList.remove('on'),3300);}
async function copyText(text){
  try{await navigator.clipboard.writeText(text);return true;}catch(_){
    const area=document.createElement('textarea');area.value=text;area.style.cssText='position:fixed;top:0;left:-9999px';document.body.append(area);area.focus();area.select();
    try{return document.execCommand('copy');}catch(_){return false;}finally{area.remove();}
  }
}
$('#copy').addEventListener('click',async()=>toast(await copyText(lastDescription.text+'\n'+tr('Lien :')+' '+shareURL(lastConfig))?tr('Votre demande a \u00e9t\u00e9 copi\u00e9e.'):tr('Copie indisponible. S\u00e9lectionnez le r\u00e9capitulatif.')));
const steps=[...document.querySelectorAll('.step')];
const stepLabels=['LA PIERRE','LA MONTURE',"L\u2019OR ET LES DIAMANTS",'VOTRE SIGNATURE','VOTRE DEMANDE'].map(label=>tr(label));
function openStep(index,focus=false){
  openIndex=index;
  for(const [i,section] of steps.entries()){
    const on=i===index-1;section.dataset.open=String(on);section.querySelector('.head').setAttribute('aria-expanded',String(on));section.querySelector('.pane').inert=!on;
  }
  if(index){$('#journeyText').textContent=`0${index} / 05   ${stepLabels[index-1]}`;$('#journeyProgress').style.width=index*20+'%';}
  if(focus&&index){const button=steps[index-1].querySelector('.head');setTimeout(()=>{button.focus({preventScroll:true});button.scrollIntoView({block:'nearest',behavior:reduceMotion()?'instant':'smooth'});},reduceMotion()?0:350);}
}
steps.forEach((section,i)=>section.querySelector('.head').addEventListener('click',()=>openStep(section.dataset.open==='true'?0:i+1)));
document.querySelectorAll('.next').forEach(button=>button.addEventListener('click',()=>openStep(Number(button.dataset.go),true)));
$('#validate').addEventListener('click',()=>openStep(5,true));
function decorateControls(){
  document.querySelectorAll('[data-s]').forEach(element=>{
    const shape=element.dataset.s;const ratio=SHAPES[shape].r;const points=sample(shape,ratio>1?20:24,ratio>1?27:24);
    const path=points.map(p=>`${(17+p[0]).toFixed(2)},${(18+p[1]).toFixed(2)}`).join(' ');
    const inner=points.map(p=>`${(17+p[0]*.6).toFixed(2)},${(18+p[1]*.6).toFixed(2)}`).join(' ');
    const step=shape==='emeraude'||shape==='baguette'?1:Math.round(points.length/8);
    const lines=points.filter((_,i)=>i%step===0).map(p=>`<path class="stone-facet" d="M${17+p[0]},${18+p[1]}L${17+p[0]*.6},${18+p[1]*.6}"/>`).join('');
    element.innerHTML=`<svg viewBox="0 0 34 36" aria-hidden="true"><polygon class="stone-fill" points="${path}"/><polygon class="stone-facet" points="${inner}"/>${lines}</svg>`;
  });
  document.querySelectorAll('[data-t]').forEach(element=>{const c=TINTS[element.dataset.t].c;element.style.background=`linear-gradient(125deg,${c[1]},${c[2]} 40%,${c[3]})`;});
  document.querySelectorAll('[data-m]').forEach(element=>{const c=METALS[element.dataset.m].c;element.style.background=`linear-gradient(130deg,${c[3]},${c[0]} 22%,${c[1]} 44%,${c[2]} 63%,${c[0]} 84%,${c[2]})`;});
  document.querySelectorAll('[data-mount]').forEach(element=>{
    const cfg={...DEFAULTS,monture:element.dataset.mount,carats:2};
    const image=new Image();image.src=MOUNT_ASSETS[cfg.monture];image.alt='';image.loading='lazy';image.decoding='async';image.addEventListener('error',()=>{element.innerHTML=scopedSVG(faceView(cfg),'mount-'+cfg.monture);},{once:true});element.replaceChildren(image);
  });
}
function fallback(){
  use3d=false;$('#gl').hidden=true;$('#fb').hidden=false;$('#chips').hidden=true;$('.scene-tools').hidden=true;$('#rotation').hidden=true;$('#finger').hidden=true;$('.drag-hint').hidden=true;$('#stage').classList.add('ready');
  $('.live-label b').textContent=tr('VUE SCH\u00c9MATIQUE');
  render();
}
function updateRotationUI(){
  const paused=!use3d||Ring3D.paused;
  $('#rotation').setAttribute('aria-pressed',String(!paused));$('#rotation').setAttribute('aria-label',tr(paused?'Activer la rotation':'Mettre la rotation en pause'));
}
$('#chips').querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>{if(use3d)Ring3D.setView(button.dataset.v);}));
$('#rotation').addEventListener('click',()=>{
  if(!use3d)return;
  if(reduceMotion()){toast(tr('Les animations sont d\u00e9sactiv\u00e9es selon vos pr\u00e9f\u00e9rences d\u2019accessibilit\u00e9.'));return;}
  Ring3D.setAuto(Ring3D.paused);updateRotationUI();
});
$('#zoom-in').addEventListener('click',()=>use3d&&Ring3D.zoom(.9));$('#zoom-out').addEventListener('click',()=>use3d&&Ring3D.zoom(1.1));
$('#fullscreen').addEventListener('click',async()=>{
  const stage=$('#stage');
  try{
    if(document.fullscreenElement)await document.exitFullscreen();
    else if(stage.requestFullscreen)await stage.requestFullscreen();
    else stage.classList.toggle('is-expanded');
  }catch(_){stage.classList.toggle('is-expanded');}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')$('#stage').classList.remove('is-expanded');});
const ROOT_EL=document.getElementById('johya-atelier')||document.documentElement,themeButton=$('#theme');
let theme='light';if(themeButton){try{theme=localStorage.getItem('johya-atelier-theme')||'light';}catch(_){}}
function setTheme(value){
  theme=value==='dark'?'dark':'light';ROOT_EL.dataset.theme=theme;
  if(themeButton){themeButton.setAttribute('aria-pressed',String(theme==='dark'));themeButton.setAttribute('aria-label',tr(theme==='dark'?'Activer le mode clair':'Activer le mode sombre'));}
  if(use3d)Ring3D.setTheme(theme);try{localStorage.setItem('johya-atelier-theme',theme);}catch(_){}
}
themeButton?.addEventListener('click',()=>setTheme(theme==='dark'?'light':'dark'));
const HELP={
  forme:['Une forme, une expression.','La taille \u00e9meraude dessine des lignes g\u00e9om\u00e9triques. L\u2019ovale allonge la silhouette, le coussin adoucit ses contours, la poire apporte une pointe, le rond une sym\u00e9trie et la baguette un rectangle net. Vous explorez ici une intention : le dessin final suivra la pierre choisie.'],
  poids:['Le poids ne dit pas tout.','Le carat mesure le poids de la pierre, pas ses dimensions. Les proportions affich\u00e9es sont une estimation, et non celles d\u2019une pierre en stock. Nous choisirons avec vous une \u00e9meraude r\u00e9elle, puis ajusterons la monture \u00e0 ses mesures.'],
  taille:['La juste mesure.','La taille fran\u00e7aise correspond au tour int\u00e9rieur de la bague, en millim\u00e8tres. Sans mesure fiable, cochez \u00ab Je ne connais pas encore ma taille \u00bb. Elle sera confirm\u00e9e avant fabrication. L\u2019aper\u00e7u n\u2019est pas un outil de mesure \u00e0 l\u2019\u00e9cran.']
};
document.querySelectorAll('[data-help]').forEach(button=>button.addEventListener('click',()=>{const data=HELP[button.dataset.help];$('#helpTitle').textContent=tr(data[0]);$('#helpText').textContent=tr(data[1]);$('#helpDialog').showModal();}));
document.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>$('#'+button.dataset.close).close()));
document.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{const rect=dialog.getBoundingClientRect();if(event.target===dialog&&(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom))dialog.close();}));
function download(content,name,type='application/json'){
  const blob=content instanceof Blob?content:new Blob([content],{type});const url=URL.createObjectURL(blob);const link=document.createElement('a');link.href=url;link.download=name;document.body.append(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),10000);
}
$('#export-config').addEventListener('click',()=>{
  const data={schema:'johya-ring-config/v2',savedAt:new Date().toISOString(),reference:lastDescription.code,configuration:read(),summary:lastDescription.rows,notice:'Etude indicative. Aucune commande ni reservation. Validation atelier requise.'};
  download(JSON.stringify(data,null,2),`JOHYA-${lastDescription.code}.json`);toast(tr('Votre projet a \u00e9t\u00e9 enregistr\u00e9 dans un fichier.'));
});
function ringCapture(){const worn=Ring3D.finger;if(worn)Ring3D.setFinger(false);try{return Ring3D.capture();}finally{if(worn)Ring3D.setFinger(true);}}
async function composedImage(branding=true){
  if(!use3d)throw new Error(tr('La vue 3D est indisponible.'));
  const data=ringCapture();const image=new Image();image.src=data;await image.decode();
  const c=document.createElement('canvas');c.width=1200;c.height=1200;const ctx=c.getContext('2d');ctx.fillStyle='#f4efe3';ctx.fillRect(0,0,c.width,c.height);
  const availableH=branding?910:1160;const scale=Math.min(1140/image.width,availableH/image.height);const w=image.width*scale,h=image.height*scale;
  ctx.drawImage(image,(1200-w)/2,(branding?100:0)+(availableH-h)/2,w,h);
  if(branding){ctx.fillStyle='#1d3329';ctx.textAlign='center';ctx.font='42px Georgia';ctx.fillText('JOHYA',600,85);ctx.font='24px Georgia';ctx.fillText(`${MONT[lastConfig.monture].n} \u00b7 ${METALS[lastConfig.metal].n}`,600,1080);ctx.font='15px Arial';ctx.fillText(`${SHAPES[lastConfig.forme].n} \u00b7 ${fmt(lastConfig.carats)} ct \u00b7 ${lastDescription.code}`,600,1119);ctx.fillStyle='#6e7369';ctx.font='12px Arial';ctx.fillText(tr('Aper\u00e7u indicatif. Pierre et proportions \u00e0 valider avec l\u2019atelier.'),600,1156);}
  return c.toDataURL('image/png');
}
$('#capture').addEventListener('click',async()=>{
  try{const data=await composedImage(true);const blob=await(await fetch(data)).blob();download(blob,`JOHYA-${lastDescription.code}.png`,'image/png');toast(tr('La vue de votre cr\u00e9ation a \u00e9t\u00e9 enregistr\u00e9e.'));}catch(error){toast(error.message);}
});
function visualConfig(config){const {ref,gravure,...safe}=config;return safe;}
function visualBrief(config){
  const safe={...config,ref:'',gravure:''};return 'Create a refined fine-jewelry studio product photograph of the emerald ring shown in the reference 3D image. Keep the exact selected setting, stone shape, number and placement of side stones, gold colour, band width and diamond pave. Pale warm ivory background #F4EFE3, soft directional studio lighting, realistic polished gold, naturally green emerald with readable facets and subtle natural inclusions. No text, logo, hands or extra jewelry. No fantasy glows. Do not add unselected diamonds. This is an indicative visual study, not a manufacturing reference.\n\n'+describe(safe).rows.map(([k,v])=>`${k}: ${v}`).join('\n');
}
async function checkAI(){
  if(location.protocol==='file:'||!API_BASE)return false;
  try{const response=await fetch(API_BASE+'status',{cache:'no-store'});if(!response.ok)return false;const result=await response.json();return result.aiAvailable===true;}catch(_){return false;}
}
function refreshAIButton(){$('#generate-ai').disabled=!aiAvailable||!use3d||!$('#aiConsent').checked||generating;}
$('#open-ai').addEventListener('click',async()=>{
  $('#aiDialog').showModal();
  if(!lastAIImage){$('#aiStatus').textContent='V\u00e9rification de la connexion au studio...';}
  aiAvailable=await checkAI();
  if(!lastAIImage)$('#aiStatus').textContent=aiAvailable?'Le studio est disponible. Une g\u00e9n\u00e9ration utilise l\u2019API payante configur\u00e9e par JOHYA.':'Le rendu IA n\u2019est pas connect\u00e9 dans cette d\u00e9monstration. Le brief visuel est disponible ci-dessous. La 3D interactive, elle, fonctionne sans IA.';
  refreshAIButton();
});
$('#aiConsent').addEventListener('change',refreshAIButton);
$('#copy-ai').addEventListener('click',async()=>toast(await copyText(visualBrief(read()))?'Le brief visuel a \u00e9t\u00e9 copi\u00e9.':'Copie indisponible.'));
$('#generate-ai').addEventListener('click',async()=>{
  if(generating||!aiAvailable||!$('#aiConsent').checked||!use3d)return;
  generating=true;refreshAIButton();$('#aiDialog').classList.add('busy');$('#aiStatus').textContent='Votre \u00e9tude de studio se pr\u00e9pare. Cette \u00e9tape peut prendre une minute ou plus.';
  const config=read(), visual=visualConfig(config), code=describe(config).code;
  try{
    const referenceImage=await composedImage(false);
    const response=await fetch(API_BASE+'render',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({configuration:visual,referenceImage,consent:true}),signal:AbortSignal.timeout(240000)});
    const result=await response.json();if(!response.ok)throw new Error(result.error||'Le studio est momentan\u00e9ment indisponible.');
    if(!/^data:image\/(png|webp|jpeg);base64,/.test(result.image||''))throw new Error('R\u00e9ponse image invalide.');
    const decodedImage=new Image();decodedImage.src=result.image;
    try{await decodedImage.decode();}catch(_){throw new Error('Le studio a renvoye une image illisible.');}
    lastAIImage=result.image;lastAIConfig=JSON.stringify(visual);lastAICode=code;
    $('#aiImage').src=result.image;$('#aiImage').hidden=false;$('#aiPlaceholder').hidden=true;
    $('#aiStatus').textContent=JSON.stringify(visualConfig(read()))!==lastAIConfig?'Ce rendu correspond aux options au moment du lancement, pas aux modifications r\u00e9centes.':`\u00c9tude indicative pour ${code}. Les d\u00e9tails doivent \u00eatre valid\u00e9s avec l\u2019atelier.`;
  }catch(error){$('#aiStatus').textContent=error.name==='TimeoutError'?'Le studio met trop de temps \u00e0 r\u00e9pondre. Aucune nouvelle tentative automatique n\u2019a \u00e9t\u00e9 lanc\u00e9e.':error.message;}
  finally{generating=false;$('#aiDialog').classList.remove('busy');refreshAIButton();}
});
function encodeConfig(config){const json=JSON.stringify(config);return btoa(unescape(encodeURIComponent(json))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');}
function decodeConfig(text){try{const b=text.replace(/-/g,'+').replace(/_/g,'/');const config=JSON.parse(decodeURIComponent(escape(atob(b+'==='.slice((b.length+3)%4)))));return config&&typeof config==='object'?config:null;}catch(_){return null;}}
function shareURL(config){const {...c}=config;for(const [k,v] of Object.entries(DEFAULTS))if(c[k]===v)delete c[k];return location.origin+location.pathname+'#c='+encodeConfig(c);}
$('#share').addEventListener('click',async()=>toast(await copyText(shareURL(read()))?tr('Le lien de votre cr\u00e9ation a \u00e9t\u00e9 copi\u00e9.'):tr('Copie indisponible.')));
function loadShared(){const m=location.hash.match(/^#c=([\w-]+)$/);if(!m)return false;const config=decodeConfig(m[1]);if(!config)return false;apply({...DEFAULTS,...config});return true;}
window.addEventListener('hashchange',()=>{if(loadShared()){render();openStep(5);}});
const VERSIONS_KEY='johya-atelier-versions';let versions=[];
try{versions=JSON.parse(localStorage.getItem(VERSIONS_KEY)||'[]').filter(v=>v&&v.config).slice(0,3);}catch(_){versions=[];}
function saveVersions(){try{localStorage.setItem(VERSIONS_KEY,JSON.stringify(versions));}catch(_){}}
async function thumb(){
  if(!use3d)return null;
  try{const image=new Image();image.src=ringCapture();await image.decode();const c=document.createElement('canvas');c.width=c.height=360;const ctx=c.getContext('2d');ctx.fillStyle=theme==='dark'?'#1b2821':'#f4efe3';ctx.fillRect(0,0,360,360);const k=Math.min(360/image.width,360/image.height)*1.08;ctx.drawImage(image,(360-image.width*k)/2,(360-image.height*k)/2,image.width*k,image.height*k);return c.toDataURL('image/jpeg',.82);}catch(_){return null;}
}
function renderVersions(){
  $('#versions').hidden=!versions.length;$('#versionsCount').textContent=`(${versions.length} / 3)`;$('#compare').hidden=versions.length<2;
  const list=$('#versionsList');list.replaceChildren();
  versions.forEach((v,i)=>{
    const card=document.createElement('div');card.className='version';
    const open=document.createElement('button');open.type='button';open.className='version-open';open.setAttribute('aria-label',`${tr('Revenir \u00e0 la version')} ${v.code}`);
    if(v.img){const img=document.createElement('img');img.src=v.img;img.alt='';open.append(img);}
    const label=document.createElement('span');label.textContent=v.code;open.append(label);
    open.addEventListener('click',()=>{apply({...DEFAULTS,...v.config});render();toast(tr('Version {code} rechargée.').replace('{code}',v.code));});
    const del=document.createElement('button');del.type='button';del.className='version-del';del.setAttribute('aria-label',`${tr('Retirer la version')} ${v.code}`);del.textContent='\u00d7';
    del.addEventListener('click',()=>{versions.splice(i,1);saveVersions();renderVersions();});
    card.append(open,del);list.append(card);
  });
}
$('#keep').addEventListener('click',async()=>{
  const config=read(),code=describe(config).code;
  if(versions.some(v=>v.code===code)){toast(tr('Cette version est d\u00e9j\u00e0 de c\u00f4t\u00e9.'));return;}
  versions.unshift({config,code,img:await thumb(),at:Date.now()});versions=versions.slice(0,3);saveVersions();renderVersions();
  toast(tr(versions.length>1?'Version mise de c\u00f4t\u00e9. Comparez-la aux pr\u00e9c\u00e9dentes.':'Version mise de c\u00f4t\u00e9. Modifiez la bague, puis gardez une autre version.'));
});
$('#compare').addEventListener('click',()=>{
  const grid=$('#compareGrid');grid.replaceChildren();grid.style.setProperty('--n',versions.length);
  for(const v of versions){
    const col=document.createElement('div');col.className='compare-col';
    if(v.img){const img=document.createElement('img');img.src=v.img;img.alt='';col.append(img);}
    const h=document.createElement('p');h.className='compare-code';h.textContent=v.code;col.append(h);
    const dl=document.createElement('dl');
    for(const [k,val] of describe({...DEFAULTS,...v.config}).rows.filter(r=>![tr('R\u00e9f\u00e9rence de la pierre'),tr('Gravure int\u00e9rieure')].includes(r[0]))){const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=k;dd.textContent=val;dl.append(dt,dd);}
    const back=document.createElement('button');back.type='button';back.className='button outline';back.textContent=tr('Choisir cette version');
    back.addEventListener('click',()=>{apply({...DEFAULTS,...v.config});render();$('#compareDialog').close();toast(tr('Version {code} rechargée.').replace('{code}',v.code));});
    col.append(dl,back);grid.append(col);
  }
  $('#compareDialog').showModal();
});
function fillSizes(){
  const rows=document.createDocumentFragment();
  for(let c=44;c<=70;c++){
    const us=Math.round((c-36.5)/2.55*2)/2,uk=Math.round((c-37.8)/1.25),tr=document.createElement('tr');
    tr.innerHTML=`<td>${c}</td><td>${fmt(c/Math.PI,1)} mm</td><td>${LOC==='en'?String(us):String(us).replace('.',',')}</td><td>${uk>25?'Z+'+(uk-25):String.fromCharCode(65+uk)}</td>`;
    if(c===Number($('#taille').value))tr.className='current';rows.append(tr);
  }
  $('#sizeRows').replaceChildren(rows);
}
$('#open-sizes').addEventListener('click',()=>{fillSizes();$('#sizesDialog').showModal();$('#sizeRows .current')?.scrollIntoView({block:'center'});});
$('#finger').addEventListener('click',()=>{
  if(!use3d)return;const on=!Ring3D.finger;Ring3D.setFinger(on);$('#finger').setAttribute('aria-pressed',String(on));
  if(on){Ring3D.setView('dessus');toast(tr('Bague port\u00e9e \u00e0 l\u2019annulaire, taille {n}, pour juger des proportions.').replace('{n}',lastConfig.tailleInc?54:lastConfig.taille));}
});
if(HOST_CONFIG.contactForm){
  $('#open-request').hidden=false;
  $('#open-request').addEventListener('click',()=>{
    const S=read(),d=describe(S);$('#reqCode').value=d.code;$('#reqLink').value=shareURL(S);$('#reqFiche').value=ficheURL(S);$('#reqBody').value=d.text;$('#requestDialog').showModal();
  });
  if(document.querySelector('[data-request-status]'))setTimeout(()=>$('#requestDialog').showModal(),300);
}
function ficheURL(config){return shareURL(config).replace('#c=','?fiche=1#c=').replace(/\?([^#]*)\?fiche=1/,'?$1&fiche=1');}
function wrapText(ctx,text,maxWidth){const words=String(text).split(' '),lines=[];let line='';for(const w of words){const t=line?line+' '+w:w;if(ctx.measureText(t).width>maxWidth&&line){lines.push(line);line=w;}else line=t;}if(line)lines.push(line);return lines;}
async function ficheCanvas(){
  if(!use3d)throw new Error(tr('La vue 3D est indisponible sur cet appareil.'));
  const S=read(),d=describe(S),W=1240,H=1754,c=document.createElement('canvas');c.width=W;c.height=H;const ctx=c.getContext('2d');
  const serif='"Cormorant Garamond",Georgia,serif',sans='Inter,Arial,sans-serif';
  try{await document.fonts.ready;}catch(_){}
  ctx.fillStyle='#f4efe3';ctx.fillRect(0,0,W,H);
  ctx.fillStyle='#1d3329';ctx.textAlign='center';ctx.font=`500 64px ${serif}`;ctx.fillText('JOHYA',W/2,120);
  ctx.font=`500 17px ${sans}`;ctx.fillStyle='#8c774d';ctx.fillText(tr('BAGUE SUR MESURE  ·  RÉF. ')+d.code,W/2,165);
  const image=new Image();image.src=ringCapture();await image.decode();
  const box={x:90,y:200,w:W-180,h:820};ctx.fillStyle='#ebe5d6';ctx.fillRect(box.x,box.y,box.w,box.h);
  // Crop to the ring itself (the capture keeps the whole stage around it).
  const t=document.createElement('canvas');t.width=image.width;t.height=image.height;const tc=t.getContext('2d');tc.drawImage(image,0,0);
  const px=tc.getImageData(0,0,t.width,t.height).data;let x0=t.width,y0=t.height,x1=0,y1=0;
  for(let yy=0;yy<t.height;yy+=2)for(let xx=0;xx<t.width;xx+=2){if(px[(yy*t.width+xx)*4+3]>24){if(xx<x0)x0=xx;if(xx>x1)x1=xx;if(yy<y0)y0=yy;if(yy>y1)y1=yy;}}
  if(x1<=x0||y1<=y0){x0=0;y0=0;x1=t.width;y1=t.height;}
  const pad=Math.round(Math.max(x1-x0,y1-y0)*.06),sx=Math.max(0,x0-pad),sy=Math.max(0,y0-pad),sw=Math.min(t.width,x1+pad)-sx,sh=Math.min(t.height,y1+pad)-sy;
  const k=Math.min((box.w-80)/sw,(box.h-80)/sh),iw=sw*k,ih=sh*k;ctx.drawImage(t,sx,sy,sw,sh,box.x+(box.w-iw)/2,box.y+(box.h-ih)/2,iw,ih);
  ctx.textAlign='left';let y=1100;ctx.fillStyle='#1d3329';ctx.font=`400 40px ${serif}`;ctx.fillText(`${MONT[S.monture].n} · ${METALS[S.metal].n}`,90,y);y+=30;
  ctx.strokeStyle='#d8d2c2';ctx.lineWidth=1;
  for(const [key,value] of d.rows){
    ctx.font=`500 15px ${sans}`;const kl=wrapText(ctx,key.toUpperCase(),300);ctx.font=`400 19px ${sans}`;const vl=wrapText(ctx,value,700);
    const h=Math.max(kl.length,vl.length)*27+20;if(y+h>H-150)break;
    ctx.beginPath();ctx.moveTo(90,y+8);ctx.lineTo(W-90,y+8);ctx.stroke();
    ctx.fillStyle='#8c774d';ctx.font=`500 15px ${sans}`;kl.forEach((l,i)=>ctx.fillText(l,90,y+38+i*27));
    ctx.fillStyle='#1d3329';ctx.font=`400 19px ${sans}`;vl.forEach((l,i)=>ctx.fillText(l,420,y+38+i*27));y+=h;
  }
  ctx.fillStyle='#6e7369';ctx.font=`400 15px ${sans}`;ctx.textAlign='center';
  ctx.fillText(tr('Visuel indicatif. Couleur, proportions et reflets seront ceux de la pierre retenue ; projet validé avec l’atelier avant fabrication.'),W/2,H-90);
  ctx.fillText('johya.com  ·  contact@johya.com  ·  '+new Date().toLocaleDateString(LOC==='en'?'en-US':LOC==='es'?'es-ES':'fr-FR'),W/2,H-60);
  return {canvas:c,code:d.code};
}
function pdfFromJpeg(bytes,w,h){
  const enc=new TextEncoder(),parts=[],xref=[];let offset=0;
  const push=x=>{const b=typeof x==='string'?enc.encode(x):x;parts.push(b);offset+=b.length;};
  const obj=(n,body,stream)=>{xref[n]=offset;push(`${n} 0 obj\n${body}\n`);if(stream){push('stream\n');push(stream);push('\nendstream\n');}push('endobj\n');};
  const PW=595.28,PH=841.89,content=`q ${PW} 0 0 ${PH} 0 0 cm /Im0 Do Q`;
  push('%PDF-1.4\n');push(new Uint8Array([37,226,227,207,211,10]));
  obj(1,'<< /Type /Catalog /Pages 2 0 R >>');
  obj(2,'<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
  obj(3,`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${PW} ${PH}] /Resources << /XObject << /Im0 5 0 R >> >> /Contents 4 0 R >>`);
  obj(4,`<< /Length ${content.length} >>`,enc.encode(content));
  obj(5,`<< /Type /XObject /Subtype /Image /Width ${w} /Height ${h} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${bytes.length} >>`,bytes);
  const start=offset;push(`xref\n0 6\n0000000000 65535 f \n${[1,2,3,4,5].map(n=>String(xref[n]).padStart(10,'0')+' 00000 n \n').join('')}trailer\n<< /Size 6 /Root 1 0 R >>\nstartxref\n${start}\n%%EOF\n`);
  return new Blob(parts,{type:'application/pdf'});
}
$('#fichePng').addEventListener('click',async()=>{try{const f=await ficheCanvas();f.canvas.toBlob(b=>download(b,`JOHYA-${f.code}.png`,'image/png'),'image/png');toast(tr('La fiche PNG a été enregistrée.'));}catch(error){toast(error.message);}});
$('#fichePdf').addEventListener('click',async()=>{try{const f=await ficheCanvas();const data=f.canvas.toDataURL('image/jpeg',.9),bin=atob(data.split(',')[1]),bytes=new Uint8Array(bin.length);for(let i=0;i<bin.length;i++)bytes[i]=bin.charCodeAt(i);download(pdfFromJpeg(bytes,f.canvas.width,f.canvas.height),`JOHYA-${f.code}.pdf`,'application/pdf');toast(tr('La fiche PDF a été enregistrée.'));}catch(error){toast(error.message);}});
const ficheMode=new URLSearchParams(location.search).get('fiche')==='1';
if(ficheMode)$('#ficheTools').hidden=false;
form.addEventListener('submit',event=>event.preventDefault());
form.addEventListener('input',render);form.addEventListener('change',render);
if($('#year'))$('#year').textContent=new Date().getFullYear();
decorateControls();
use3d=typeof THREE!=='undefined'&&typeof Ring3D!=='undefined'&&Ring3D.init($('#gl'));
if(use3d){
  Ring3D.onView(name=>{document.querySelectorAll('#chips button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.v===name)));if(name!=='angle')Ring3D.setAuto(false);updateRotationUI();});
  $('#gl').addEventListener('ring3d-lost',fallback);$('#gl').addEventListener('ring3d-pause',updateRotationUI);
  requestAnimationFrame(()=>$('#stage').classList.add('ready'));
  $('#finger').hidden=true;
}else fallback();
const shared=loadShared();
openStep(shared||new URLSearchParams(location.search).get('fiche')==='1'?5:1);setTheme(theme);updateRotationUI();render();renderVersions();
checkAI().then(ok=>{aiAvailable=ok;$('#open-ai').hidden=!ok;});
window.JohyaAtelier={read,apply:(config)=>{apply(config);render();},openStep,visualBrief,refresh:render,shareURL,decodeConfig,get use3d(){return use3d;}};

;
/* stock.js */
(function () {
  'use strict';
  var data = document.getElementById('atelierStock');
  var select = document.getElementById('stockPick');
  var info = document.getElementById('stockInfo');
  var form = document.getElementById('cfg');
  if (!select || !info || !form) return;
  var field = select.closest('.stock-field');
  var hostConfig = window.JOHYA_ATELIER_CONFIG || {};
  var tr = typeof JA_T === 'function' ? JA_T : function (text) { return text; };
  var loc = typeof JA_LOC === 'string' ? JA_LOC : 'fr';

  if (data) {
    var inline = [];
    try { inline = JSON.parse(data.textContent); } catch (e) { inline = []; }
    setup(inline);
  } else if (hostConfig.api !== false && location.protocol !== 'file:') {
    fetch((hostConfig.api || './api/') + 'stock', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : { stones: [] }; })
      .then(function (j) { setup(Array.isArray(j.stones) ? j.stones : []); })
      .catch(function () { setup([]); });
  } else {
    setup([]);
  }

  function setup(stones) {
    function shapeKey(label) {
      var s = (label || '').toLowerCase();
      if (/oval/.test(s)) return 'ovale';
      if (/poire|pear|pera/.test(s)) return 'poire';
      if (/coussin|cushion|coj/.test(s)) return 'coussin';
      if (/rond|round|redond/.test(s)) return 'rond';
      if (/baguette|rectang/.test(s)) return 'baguette';
      if (/meraude|emerald|esmeralda/.test(s)) return 'emeraude';
      return '';
    }

    function tintKey(label) {
      var s = (label || '').toLowerCase();
      if (/bleut|bluish|azul/.test(s)) return 'chivor';
      if (/deep|profond|profund/.test(s)) return 'profond';
      if (/intens/.test(s)) return 'intense';
      if (/light|clair|claro/.test(s)) return 'clair';
      return 'vivid';
    }

    var TINT_SKU = { CD80: 'chivor' };
    var NUANCES = { 'light green': 'vert clair', 'medium green': 'vert moyen', 'intense green': 'vert intense', 'deep green': 'vert profond', 'bluish green': 'vert bleuté' };
    function nuanceFr(label) {
      var k = (label || '').toLowerCase().trim();
      return loc === 'fr' ? (NUANCES[k] || label || '') : (label || '');
    }

    var euro = new Intl.NumberFormat(loc === 'en' ? 'en-US' : loc === 'es' ? 'es-ES' : 'fr-FR', { style: 'currency', currency: hostConfig.currency || 'EUR', maximumFractionDigits: 0 });
    function ct(n) { return (loc === 'en' ? String(n) : String(n).replace('.', ',')) + ' ct'; }

    stones = stones.filter(function (s) {
      s.shape = shapeKey(s.forme);
      s.weight = Number(s.weight) || 0;
      return s.shape && s.weight > 0 && s.sku;
    }).sort(function (a, b) { return a.weight - b.weight; });

    if (!stones.length) {
      field.hidden = true;
      return;
    }
    field.hidden = false;

    stones.forEach(function (s, i) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = s.sku + ' · ' + ct(s.weight) + ' · ' + s.forme + ' · ' + euro.format(s.price / 100);
      select.appendChild(o);
    });
    document.getElementById('stockCount').textContent = stones.length;

    function check(name, value) {
      var input = form.querySelector('input[name="' + name + '"][value="' + value + '"]');
      if (input) input.checked = true;
    }

    var real = document.getElementById('realStone');
    var priceNote = document.getElementById('priceNote');
    var current = null;
    function stage(s) {
      current = s;
      if (priceNote) {
        priceNote.hidden = !s;
        priceNote.textContent = s ? tr('Pierre') + ' ' + s.sku + (loc === 'fr' ? ' : ' : ': ') + euro.format(s.price / 100) + ' ' + tr('TTC') : '';
      }
      if (!real) return;
      var pic = s && (s.photo || s.image);
      real.hidden = !pic;
      if (!pic) return;
      document.getElementById('realThumb').src = s.image || s.photo;
      document.getElementById('realSku').textContent = s.sku;
      document.getElementById('realPlay').hidden = !s.video;
    }
    if (real) real.addEventListener('click', function () {
      if (!current) return;
      var viewer = document.getElementById('realViewer');
      viewer.textContent = '';
      if (current.video) {
        var v = document.createElement('video');
        v.src = current.video; v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true; v.controls = true;
        if (current.photo) v.poster = current.photo;
        viewer.appendChild(v);
      } else {
        var im = document.createElement('img');
        im.src = current.photo || current.image; im.alt = current.title;
        viewer.appendChild(im);
      }
      document.getElementById('realTitle').textContent = current.title;
      document.getElementById('realLine').textContent = current.sku + ' · ' + ct(current.weight) + ' · ' + (current.nuance ? nuanceFr(current.nuance) + ' · ' : '') + euro.format(current.price / 100) + ' ' + tr('TTC, pierre seule');
      document.getElementById('realLink').href = current.url;
      var dialog = document.getElementById('realDialog');
      dialog.showModal();
      dialog.addEventListener('close', function () { viewer.textContent = ''; }, { once: true });
    });

    function show(s) {
      info.textContent = '';
      stage(s);
      if (!s) { info.hidden = true; return; }
      if (s.image) {
        var thumb = document.createElement('span');
        thumb.className = 'stock-thumb';
        var img = document.createElement('img');
        img.src = s.image; img.alt = ''; img.width = 56; img.height = 56;
        thumb.appendChild(img);
        info.appendChild(thumb);
      }
      var box = document.createElement('div');
      var title = document.createElement('strong');
      title.textContent = s.title;
      var line = document.createElement('span');
      line.textContent = s.sku + ' · ' + (s.nuance ? nuanceFr(s.nuance) + ' · ' : '') + euro.format(s.price / 100) + ' ' + tr('TTC, pierre seule');
      box.appendChild(title); box.appendChild(line);
      if (s.traitement) {
        var t = document.createElement('span');
        t.textContent = tr('Traitement :') + ' ' + s.traitement;
        box.appendChild(t);
      }
      if (s.weight < (Number(document.getElementById('carats').min) || 0.5) || s.weight > (Number(document.getElementById('carats').max) || 5)) {
        var note = document.createElement('span');
        note.textContent = tr('Poids réel {ct} : la vue 3D est réglée sur la valeur la plus proche.').replace('{ct}', ct(s.weight));
        box.appendChild(note);
      }
      var link = document.createElement('a');
      link.href = s.url; link.target = '_blank'; link.rel = 'noopener';
      link.textContent = tr('Voir la fiche de la pierre');
      box.appendChild(link);
      info.appendChild(box);
      info.hidden = false;
    }

    select.addEventListener('change', function () {
      var s = stones[Number(select.value)];
      if (!s) {
        document.getElementById('ref').value = '';
        show(null);
        form.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      check('forme', s.shape);
      check('teinte', TINT_SKU[String(s.sku).toUpperCase()] || tintKey(s.nuance));
      var range = document.getElementById('carats');
      var w = Math.min(Number(range.max) || 5, Math.max(Number(range.min) || 0.5, Math.round(s.weight * 100) / 100));
      document.getElementById('carats').value = w;
      document.getElementById('ref').value = s.sku;
      show(s);
      form.dispatchEvent(new Event('input', { bubbles: true }));
      form.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var asked = (new URLSearchParams(location.search).get('pierre') || '').trim().toUpperCase();
    if (asked) stones.forEach(function (s, i) {
      if (s.sku.toUpperCase() === asked) { select.value = String(i); select.dispatchEvent(new Event('change')); }
    });
    var preset = document.getElementById('ref').value.trim();
    if (preset) stones.forEach(function (s, i) { if (s.sku === preset) { select.value = String(i); show(s); } });

    document.getElementById('ref').addEventListener('input', function () {
      var cur = stones[Number(select.value)];
      if (cur && this.value.trim() !== cur.sku) { select.value = ''; show(null); }
    });
  }
})();

window.Ring3D=Ring3D;
})();
